import type { MessageCatalog } from "./ko";

export const en: MessageCatalog = {
  "imageRelay.title": "Connect Windows app",
  "imageRelay.description":
    "Connect Image Relay for Windows to your Locktree account.",
  "imageRelay.loading": "Checking your account and connection request…",
  "imageRelay.signInHelp":
    "Sign in to the Locktree account that should receive your images.",
  "imageRelay.signIn": "Sign in to Locktree",
  "imageRelay.account": "Account for uploaded images",
  "imageRelay.permission":
    "Allow the app to upload images from the folder you select to this account.",
  "imageRelay.confirmDevice":
    "Allow this connection only if you started sign-in in the Windows app yourself.",
  "imageRelay.approve": "Allow app connection",
  "imageRelay.deny": "Cancel",
  "imageRelay.connecting": "Returning to the app…",
  "imageRelay.invalidRequest":
    "This request has expired or is invalid. Start sign-in again in the Windows app.",
  "imageRelay.accountChanged":
    "The reviewed account has changed. Start sign-in again in the Windows app.",
  "imageRelay.unavailable":
    "The connection could not be verified. Try again from the Windows app shortly.",
  "app.documentTitle": "Locktree - Professional Poker Solver",
  "nav.solver": "Solver",
  "nav.aiSetup": "AI Setup",
  "nav.history": "History",
  "nav.solutions": "Solutions",
  "nav.settings": "Settings",
  "nav.signIn": "Sign In",
  "nav.logout": "Logout",
  "nav.openMenu": "Open menu",
  "nav.closeMenu": "Close menu",
  "nav.language": "Language",
  "common.dismiss": "Dismiss",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.clear": "Clear",
  "common.remove": "Remove",
  "common.retry": "Retry",
  "common.refresh": "Refresh",
  "common.edit": "Edit",
  "common.copy": "Copy",
  "common.error": "Error:",
  "common.warning": "Warning:",
  "common.fold": "Fold",
  "common.check": "Check",
  "common.call": "Call",
  "common.bet": "Bet",
  "common.raise": "Raise",
  "common.allIn": "All-In",
  "solverStreet.preflop": "Preflop",
  "solverStreet.flop": "Flop",
  "solverStreet.turn": "Turn",
  "solverStreet.river": "River",
  "solverStreet.unknown": "Unknown",
  "solverAction.fold": "Fold",
  "solverAction.check": "Check",
  "solverAction.call": "Call",
  "solverAction.bet": "Bet",
  "solverAction.raise": "Raise",
  "solverAction.allin": "Allin",
  "solverAction.short.call": "C",
  "solverAction.short.bet": "B",
  "solverAction.short.raise": "R",
  "solverAction.short.allin": "A",
  "common.itemCount.one": "{count} item",
  "common.itemCount.other": "{count} items",
  "settings.title": "Settings",
  "settings.language": "Language",
  "settings.languageDescription":
    "Choose the language for the interface. Your choice is saved in this browser.",
  "locale.ko": "한국어",
  "locale.en": "English",
  "about.tagline": "GTO Poker Solver",
  "about.aiSetup": "AI Setup",
  "about.aiSetupDescription": "Upload a screenshot and analyze automatically",
  "about.postflopSolver": "Postflop Solver",
  "about.postflopSolverDescription":
    "Configure ranges, board, and solve manually",
  "about.preflopSolutions": "Preflop Solutions",
  "about.preflopSolutionsDescription":
    "Preflop GTO solutions with strategy viewer",
  "about.history": "History",
  "about.historyDescription": "View past solves and saved configurations",
  "about.client": "Client",
  "about.server": "Server",
  "about.loading": "loading...",
  "about.deployed": "Deployed",
  "authError.signInFailed": "Sign-in failed",
  "authError.title": "Unable to sign in",
  "authError.retryLogin": "Sign in again",
  "authError.goHome": "Go home",
  "boardSelector.randomFlop": "Random Flop",
  "boardSelector.expectedBoard":
    "The edited tree assumes a {count}-card board.",
  "cardPicker.selectCard": "Select Card",
  "convergence.previewMode": "Preview Mode",
  "convergence.iteration": "Iteration {iteration}",
  "convergence.confidence": "Confidence {confidence}%",
  "convergence.strategyStability": "Strategy stability: {percent}%",
  "convergence.backToSolver": "Back to Solver",
  "rangeEditor.weight": "Weight:",
  "rangeEditor.comboCount.one": "{count} combo ({percent}%)",
  "rangeEditor.comboCount.other": "{count} combos ({percent}%)",
  "resultCompare.combos": "Combos",
  "resultCompare.equity": "Equity",
  "handRange.title": "Hand Range",
  "handRange.notInRange": "Not in range",
  "handRange.frequency": "Frequency",
  "handRange.comboCount.one": "{count} combo ({percent}%)",
  "handRange.comboCount.other": "{count} combos ({percent}%)",
  "handRange.hoveredCombo.one": "{count} combo",
  "handRange.hoveredCombo.other": "{count} combos",
  "preflopAction.title": "Preflop Action Timeline",
  "preflopAction.pot": "Pot:",
  "preflopAction.result": "Result",
  "preflopAction.winner": "Winner: {winner}",
  "preflopAction.totalPot": "Total Pot: {pot}",
  "preflopAction.chips": "chips",
  "rangeSwitcher.regionLabel": "GTO action frequency switcher for {player}",
  "rangeSwitcher.loadedFromTree": "Range loaded from GTO preflop tree",
  "rangeSwitcher.dismiss": "Dismiss GTO range switcher",
  "rangeSwitcher.optionsLabel": "Action frequency options for {player}",
  "rangeSwitcher.showRange": "Show {action} range",
  "rangeSwitcher.noHands": "no hands",
  "rangeSwitcher.showRangeWithCombos.one":
    "Show {action} range — {count} combo",
  "rangeSwitcher.showRangeWithCombos.other":
    "Show {action} range — {count} combos",
  "treeConfig.startingPot": "Starting pot:",
  "treeConfig.effectiveStack": "Effective stack:",
  "treeConfig.rake": "Rake:",
  "treeConfig.rakeCap": "Rake cap:",
  "treeConfig.oopBetSizes": "OOP bet sizes",
  "treeConfig.differentDonkSizes": "Use different sizes for donk bets",
  "treeConfig.howToInput": "How to input",
  "treeConfig.betSizeInputHelp":
    "Multiple bet sizes can be input, separated by commas or spaces, in any of the following sizes. If left blank, no bet or raise will be made.",
  "treeConfig.potPercentageHelp":
    "A number representing a percentage of the pot (e.g., ‘50’). For raises, the size is calculated by first calling and then combining a bet of the specified percentage. For example, if the pot is 100 before the bet, and the opponent bets 75, a raise of 50% would result in a bet of 75 + (100 + 75 + 75) * 50% = 200.",
  "treeConfig.betMultipleHelp":
    "A multiple of the previous bet size (e.g., ‘2.5x’). Only valid for raises.",
  "treeConfig.allInHelp": "All-in (e.g., ‘a’).",
  "treeConfig.constantAdditionHelp":
    "Constant addition (e.g., ‘100c’). For raises, you can also specify a cap on the number of raises (e.g., ‘20c3r’).",
  "treeConfig.geometricSizeHelp":
    "Geometric size, i.e., dividing the remaining stack into a specified number of equal percentage bets (e.g., ‘3e’). For example, if the current pot is 100 and the effective stack is 400, ‘2e’ would result in a bet of 100. If the number before the ‘e’ is omitted, the number of remaining streets is used (flop=3, turn=2, river=1). For raises, the number of previous raises is subtracted from the specified number. For example, ‘3e’ will change to ‘2e’ on re-raises. You can also specify a maximum percentage limit by adding a number after the ‘e’ (e.g., ‘2e200’).",
  "treeConfig.flop": "Flop",
  "treeConfig.turn": "Turn",
  "treeConfig.river": "River",
  "treeConfig.bet": "Bet:",
  "treeConfig.raise": "Raise:",
  "treeConfig.donk": "Donk:",
  "treeConfig.ipBetSizes": "IP bet sizes",
  "treeConfig.copyIpToOop": "Copy IP sizes to OOP",
  "treeConfig.copyOopToIp": "Copy OOP sizes to IP",
  "treeConfig.addAllInThreshold": "Add all-in threshold:",
  "treeConfig.addAllInThresholdHelp":
    "Add all-in action to all spots where the ratio of the maximum possible betting size to the pot is less than this threshold.",
  "treeConfig.forceAllInThreshold": "Force all-in threshold:",
  "treeConfig.forceAllInThresholdHelp":
    "Replace the betting action with an all-in action if the SPR (Stack/Pot Ratio) is below this threshold after the betting action is called by the opponent. The recommended value is around 15% - 20%.",
  "treeConfig.pioAllInThresholdHelp":
    "This option is similar to the ‘all-in threshold’ in PioSOLVER. PioSOLVER will replace the betting action with an all-in if the percentage of one's pot commitment to the initial stack exceeds the threshold.",
  "treeConfig.conversionFormulaHelp":
    "The conversion formula, when ignoring decimal rounding, is as follows (s = initial SPR, r = PioSOLVER's threshold):",
  "treeConfig.thresholdFormula": "Threshold = s * (1 - r) / (1 + 2 * s * r).",
  "treeConfig.mergingThreshold": "Merging threshold:",
  "treeConfig.mergingThresholdHelp":
    "Merge betting actions if there are betting actions of similar size.",
  "treeConfig.mergingAlgorithmHelp":
    "The algorithm is the same as in PioSOLVER. That is, select the largest bet size (= X% of the pot) and remove all other betting actions with sizes (= Y% of the pot) that satisfy the following inequality:",
  "treeConfig.mergingInequality": "(100 + X) / (100 + Y) < 1.0 + Threshold.",
  "treeConfig.mergingRepeatHelp":
    "Repeat this process with the next largest bet size among the remaining bets.",
  "treeConfig.previewEditTree": "Preview & Edit Tree",
  "treeConfig.clearEditUnlock": "Clear Edit & Unlock",
  "treeConfig.addedLine.one": "Added line:",
  "treeConfig.addedLine.other": "Added lines:",
  "treeConfig.removedLine.one": "Removed line:",
  "treeConfig.removedLine.other": "Removed lines:",
  "treeConfig.boardMismatch":
    "The edited tree assumes a {expected}-card board, but the current board consists of {actual} cards.",
  "treeConfig.resetEditedTree":
    "To reset the edited tree, click the ‘Clear Edit & Unlock’ button.",
  "treeConfig.failedBuildBrokenTree":
    "Error: Failed to build tree (loaded broken tree?)",
  "treeConfig.pot": "Pot {pot}",
  "treeConfig.stack": "Stack {stack}",
  "treeConfig.playerWins": "{player} Wins",
  "treeConfig.noActions": "(No actions)",
  "treeConfig.invalidTerminal.one": "Invalid Terminal:",
  "treeConfig.invalidTerminal.other": "Invalid Terminals:",
  "treeConfig.addBetAction": "Add Bet Action",
  "treeConfig.removeSelectedNode": "Remove Selected Node",
  "treeConfig.betAmount": "Bet amount:",
  "treeConfig.percentOfPot": "({percent}% of the pot)",
  "treeConfig.saveEdit": "Save Edit",
  "treeConfig.cancelEdit": "Cancel Edit",
  "treeConfig.oopRangeEmpty": "OOP range is empty (select at least one hand)",
  "treeConfig.ipRangeEmpty": "IP range is empty (select at least one hand)",
  "treeConfig.boardTooShort": "Board must consist of at least three cards",
  "treeConfig.startingPotPositive": "Starting pot must be positive",
  "treeConfig.startingPotTooLarge": "Starting pot is too large",
  "treeConfig.startingPotMax": "Starting pot must not exceed {max}",
  "treeConfig.effectiveStackPositive": "Effective stack must be positive",
  "treeConfig.effectiveStackTooLarge": "Effective stack is too large",
  "treeConfig.effectiveStackMax": "Effective stack must not exceed {max}",
  "treeConfig.rakeNonNegative": "Rake must be non-negative",
  "treeConfig.rakeMax": "Rake must not exceed 100%",
  "treeConfig.rakeCapNonNegative": "Rake cap must be non-negative",
  "treeConfig.rakeCapMax": "Rake cap must not exceed {max}",
  "treeConfig.invalidBetSize": "{name}: {value}",
  "treeConfig.addAllInNonNegative": "Add all-in threshold must be non-negative",
  "treeConfig.forceAllInNonNegative":
    "Force all-in threshold must be non-negative",
  "treeConfig.mergingNonNegative": "Merging threshold must be non-negative",
  "treeConfig.forceAllInHighWarning":
    "Force all-in threshold higher than 30% is not recommended.\nPlease see help to confirm the meaning.",
  "treeConfig.invalidLine":
    "Invalid line found (loaded broken configurations?)",
  "treeConfig.invalidConfiguration":
    "Invalid configurations (loaded broken configurations?)",
  "treeConfig.oopFlopBet": "OOP flop bet",
  "treeConfig.oopFlopRaise": "OOP flop raise",
  "treeConfig.oopTurnBet": "OOP turn bet",
  "treeConfig.oopTurnRaise": "OOP turn raise",
  "treeConfig.oopTurnDonk": "OOP turn donk",
  "treeConfig.oopRiverBet": "OOP river bet",
  "treeConfig.oopRiverRaise": "OOP river raise",
  "treeConfig.oopRiverDonk": "OOP river donk",
  "treeConfig.ipFlopBet": "IP flop bet",
  "treeConfig.ipFlopRaise": "IP flop raise",
  "treeConfig.ipTurnBet": "IP turn bet",
  "treeConfig.ipTurnRaise": "IP turn raise",
  "treeConfig.ipRiverBet": "IP river bet",
  "treeConfig.ipRiverRaise": "IP river raise",
  "treeConfig.initializeHandlerFailed": "Failed to initialize solver handler",
  "treeConfig.cannotBuild": "Cannot build tree: {error}",
  "treeConfig.buildFailed": "Failed to build tree: {error}",
  "treeConfig.loadTreeFailed": "Failed to load game tree",
  "treeConfig.errorWithMessage": "Error: {error}",
  "treeConfig.addActionFailed":
    "Failed to add action. Check console for details.",
  "treeConfig.removeAddedLineFailed":
    "Failed to remove added line. Check console for details.",
  "treeConfig.restoreRemovedLineFailed":
    "Failed to restore removed line. Check console for details.",
  "nodeLock.title": "Node Locks",
  "nodeLock.strategy": "Strategy:",
  "nodeLock.nodeRemoval": "Node Removal:",
  "nodeLock.rangeLock": "Range Lock:",
  "nodeLock.evLock": "EV Lock:",
  "nodeLock.sortBy": "Sort by:",
  "nodeLock.lockId": "Lock ID",
  "nodeLock.lockType": "Lock Type",
  "nodeLock.nodePath": "Node Path",
  "nodeLock.status": "Status",
  "nodeLock.sortAscending": "Sort ascending",
  "nodeLock.sortDescending": "Sort descending",
  "nodeLock.filter": "Filter:",
  "nodeLock.allLocks": "All Locks",
  "nodeLock.strategyOnly": "Strategy Only",
  "nodeLock.nodeRemovalOnly": "Node Removal Only",
  "nodeLock.rangeLockOnly": "Range Lock Only",
  "nodeLock.evLockOnly": "EV Lock Only",
  "nodeLock.enabledOnly": "Enabled Only",
  "nodeLock.disabledOnly": "Disabled Only",
  "nodeLock.loading": "Loading locks...",
  "nodeLock.disabled": "(Disabled)",
  "nodeLock.noDescription": "No description",
  "nodeLock.path": "Path: {path}",
  "nodeLock.toggle": "Toggle lock",
  "nodeLock.enabling": "Enabling...",
  "nodeLock.disabling": "Disabling...",
  "nodeLock.enable": "Enable",
  "nodeLock.disable": "Disable",
  "nodeLock.copy": "Copy lock",
  "nodeLock.edit": "Edit lock",
  "nodeLock.remove": "Remove lock",
  "nodeLock.deleting": "Deleting...",
  "nodeLock.lockedStrategies": "Locked Strategies:",
  "nodeLock.hand": "Hand {index}:",
  "nodeLock.removedActions": "Removed Actions:",
  "nodeLock.indices": "(indices: {indices})",
  "nodeLock.handCombinations.one": "{count} hand combination locked",
  "nodeLock.handCombinations.other": "{count} hand combinations locked",
  "nodeLock.weights": "(weights: {weights}{ellipsis})",
  "nodeLock.noFilterMatches": "No locks match the current filter",
  "nodeLock.noLocks": "No locks configured",
  "nodeLock.createForCurrentNode":
    "Create a lock for the currently selected node",
  "nodeLock.lockThisNode": "Lock This Node",
  "nodeLock.addLock": "+ Add Lock",
  "nodeLock.loadFailed": "Failed to load locks",
  "nodeLock.loadNetworkError": "Network error while loading locks",
  "nodeLock.toggleFailed": "Failed to toggle lock",
  "nodeLock.toggleNetworkError": "Network error while toggling lock",
  "nodeLock.removeConfirmation": "Are you sure you want to remove this lock?",
  "nodeLock.removeFailed": "Failed to remove lock",
  "nodeLock.removeNetworkError": "Network error while removing lock",
  "nodeLock.strategyType": "Strategy",
  "nodeLock.nodeRemovalType": "Node Removal",
  "nodeLock.rangeLockType": "Range Lock",
  "nodeLock.evLockType": "EV Lock",
  "nodeLock.foldAction": "Fold",
  "nodeLock.callCheckAction": "Call/Check",
  "nodeLock.betRaiseAction": "Bet/Raise",
  "nodeLock.action": "Action {index}",
  "runSolver.buildNewTree": "Build New Tree",
  "runSolver.status": "Status: {status}",
  "runSolver.configureThenBuild":
    "Configure your solver settings, then click Build New Tree to start.",
  "runSolver.setupRanges":
    "Set up ranges in AI Setup or manually via OOP/IP Range",
  "runSolver.configureTree":
    "Configure board, pot, and stack in Tree Configuration",
  "runSolver.buildThenRun": "Build tree, then run solver",
  "runSolver.viewTree": "View Tree",
  "runSolver.precisionMode": "Precision mode:",
  "runSolver.precisionHelp":
    "Precision mode mainly affects memory usage, but it also has several other effects.",
  "runSolver.fp32Help":
    "32-bit FP (floating-point): This is recommended if the memory usage is below the limit (= 3.9GB). It has about 7 significant digits and better performance.",
  "runSolver.int16Help":
    "16-bit integer: This setting can help to avoid the memory limit if the 32-bit FP mode is not usable. Since the significant digits are about 4 digits, it is not suitable for satisfying an exploitability target below 0.1%. Performance is also worse than in 32-bit FP mode.",
  "runSolver.fp32": "32-bit FP:",
  "runSolver.int16": "16-bit integer:",
  "runSolver.memoryRequirement": "needs {memory} RAM{limit}",
  "runSolver.limitExceeded": " (limit exceeded)",
  "runSolver.ramLimit": "RAM limit: 3.9GB (browser memory limit)",
  "runSolver.targetExploitability": "Target exploitability:",
  "runSolver.targetHelp":
    "Specifies the acceptable distance to the Nash equilibrium. A lower value gives more accurate results, but also requires more computation time.",
  "runSolver.detailedDescription": "A more detailed description:",
  "runSolver.targetDetails":
    "When a Nash equilibrium solution is obtained, the strategies of both players become MESs (Maximally Exploitative Strategies) to each other. Using this property, we define the distance to the Nash equilibrium of the obtained strategy as follows:",
  "runSolver.distanceFormula":
    "Distance = (Opponent's MES EV) - (Opponent's obtained EV).",
  "runSolver.exploitabilityDetails":
    "This distance is always non-negative and is zero if and only if the obtained strategy is a part of a particular Nash equilibrium. Exploitability is defined as the average distance of both players.",
  "runSolver.maxIterations": "Maximum number of iterations:",
  "runSolver.run": "Run Solver",
  "runSolver.stop": "Stop",
  "runSolver.pause": "Pause",
  "runSolver.resume": "Resume",
  "runSolver.running": "Solver running...",
  "runSolver.finalizing": "Finalizing...",
  "runSolver.paused": "Solver paused.",
  "runSolver.finished": "Solver finished.",
  "runSolver.starting": "Starting solver...",
  "runSolver.iteration": "Iteration: {current} / {max}",
  "runSolver.solvingPrefix": "Solving... ",
  "runSolver.exploitabilityNotConverged":
    "{prefix}Exploitability: Not converged ({percent}% of pot)",
  "runSolver.exploitability": "{prefix}Exploitability: {value} ({percent}%)",
  "runSolver.strategyStability": "Strategy stability: {percent}%",
  "runSolver.time": "Time: {seconds}s",
  "runSolver.progressStalled":
    "Progress updates have stalled. The server may be experiencing issues.",
  "runSolver.previewResults": "Preview Results",
  "runSolver.invalidBoard": "Invalid board (expected {count} cards)",
  "runSolver.buildingTree": "Building tree...",
  "runSolver.buildSuccess": "Successfully built tree",
  "runSolver.unknownError": "Unknown error",
  "runSolver.startFailed": "Failed to start solver: {error}",
  "runSolver.previewFailed": "Failed to preview results: {error}",
  "runSolver.solverError": "Solver error: {error}",
  "addLock.editTitle": "Edit Node Lock",
  "addLock.addTitle": "Add Node Lock",
  "addLock.lockType": "Lock Type",
  "addLock.strategyLock": "Strategy Lock",
  "addLock.nodeRemoval": "Node Removal",
  "addLock.rangeLock": "Range Lock",
  "addLock.strategyDescription":
    "Fix specific hand strategies at a node (e.g., AA always raises)",
  "addLock.nodeRemovalDescription":
    "Remove specific actions from the decision tree (e.g., disable fold)",
  "addLock.rangeLockDescription":
    "Lock player range weights at a specific node",
  "addLock.quickTemplates": "Quick Templates",
  "addLock.clearTemplate": "Clear Template",
  "addLock.selectTemplate": "-- Select a template (optional) --",
  "addLock.nodePath": "Node Path",
  "addLock.nodePathHint": '(comma-separated action indices, e.g., "0,1,2")',
  "addLock.nodePathHelp":
    'Empty = root node. Example: "0" = first action, "0,1" = first action then second action',
  "addLock.description": "Description",
  "addLock.descriptionPlaceholder": "e.g., AA always raises",
  "addLock.lockedStrategies": "Locked Strategies",
  "addLock.strategyHint": "(hand: action probabilities)",
  "addLock.strategyHandLabel": "Locked strategy {index} hand",
  "addLock.strategyProbabilitiesLabel":
    "Locked strategy {index} action probabilities",
  "addLock.handPlaceholder": "AA, AKs, etc.",
  "addLock.probabilitiesPlaceholder": "e.g., 0.0,1.0,0.0",
  "addLock.addHand": "+ Add Hand",
  "addLock.strategyExample":
    'Example: "AA" with probabilities "0.0,1.0,0.0" means AA folds with 0%, calls with 100%, raises with 0%. You can use hand notation like "AA", "KK", "AKs" (suited), "AKo" (offsuit), or hand index numbers (0-1325).',
  "addLock.removedActions": "Removed Actions",
  "addLock.removedActionsHint": "(action indices to remove)",
  "addLock.removedActionsPlaceholder": "e.g., 0,2 (removes fold and raise)",
  "addLock.removedActionsHelp":
    'Enter comma-separated action indices. Example: "0" removes fold, "0,2" removes fold and raise',
  "addLock.lockedRange": "Locked Range",
  "addLock.handNotation": "Hand Notation",
  "addLock.manualWeights": "Manual Weights",
  "addLock.notationPlaceholder": "e.g., AA, KK, QQ+, AKs, AKo",
  "addLock.notationHelp":
    "Enter hand combinations using poker notation: AA, KK+, AKs, AKo, 77-22, etc. All listed hands will have weight 1.0, unlisted hands will have weight 0.0.",
  "addLock.weightsPlaceholder": "e.g., 1.0,1.0,0.5,0.0,...",
  "addLock.weightsHelp":
    "Enter 1326 comma-separated weights (one per hand combination). 1.0 = always in range, 0.0 = never in range.",
  "addLock.conflictsDetected": "⚠️ Potential Lock Conflicts Detected:",
  "addLock.conflictsHelp":
    "You can still create this lock, but it may interact unexpectedly with existing locks.",
  "addLock.updating": "Updating...",
  "addLock.adding": "Adding...",
  "addLock.updateLock": "Update Lock",
  "addLock.addLock": "Add Lock",
  "addLock.sameTypeConflict":
    "Another {type} lock already exists at this node (ID: {id})",
  "addLock.removalAffectsStrategy":
    "A node_removal lock exists here - strategy locks may be affected by removed actions",
  "addLock.strategyConflictsRemoval":
    "A strategy lock exists here - removing actions may conflict with locked strategies",
  "addLock.rangeConflict":
    "A {type} lock exists here - range locks affect all hands and may override other locks",
  "addLock.parentRangeConflict":
    "This range lock affects a parent node of lock {id}, which may limit child strategies",
  "addLock.parentHasRange":
    "Parent node has a range lock ({id}), which may limit this lock's effectiveness",
  "addLock.parentHasRemoval":
    "Parent node has a node_removal lock ({id}), which may affect available actions",
  "addLock.noStrategies":
    "No hand strategies configured. Please add at least one hand with action probabilities (e.g., AA with probabilities 0.0,1.0,0.0).",
  "addLock.strategyDefaultDescription": "Strategy lock",
  "addLock.nodeRemovalDefaultDescription": "Node removal lock",
  "addLock.rangeDefaultDescription": "Range lock",
  "addLock.noHandCombinations":
    "No hand combinations specified. Please enter poker hand notation (e.g., 'AA, KK+, AKs, AKo').",
  "addLock.invalidNotation":
    "Invalid hand notation: {error}. Use poker notation like 'AA', 'KK+', 'AKs', 'AKo', or '77-22'.",
  "addLock.noRangeWeights":
    "No range weights specified. Please enter 1326 comma-separated decimal values between 0.0 and 1.0.",
  "addLock.invalidWeightsFormat":
    "Invalid range weights format. Expected 1326 comma-separated decimal numbers (e.g., '1.0,0.5,0.0,...'), but found non-numeric values.",
  "addLock.invalidWeight":
    "Invalid weight value: {value}. All range weights must be between 0.0 and 1.0.",
  "addLock.weightCount":
    "Range lock requires exactly 1326 weights for all hand combinations (got {count}). Each weight represents one possible starting hand.",
  "addLock.invalidType": "Invalid lock type",
  "addLock.addFailed": "Failed to add lock",
  "addLock.editRollback":
    "Failed to remove original lock during edit. Changes have been rolled back.",
  "addLock.changesRolledBack": " (Changes rolled back)",
  "addLock.rollbackFailed":
    " (WARNING: Rollback failed - both old and new locks may exist!)",
  "addLock.templatePremiumRaiseName": "Premium Hands Always Raise",
  "addLock.templatePremiumRaiseDescription":
    "AA, KK, QQ always raise (never fold or call)",
  "addLock.templateAcesNeverFoldName": "Pocket Aces Never Fold",
  "addLock.templateAcesNeverFoldDescription":
    "AA always calls or raises (never folds)",
  "addLock.templateWeakFoldName": "Weak Hands Always Fold",
  "addLock.templateWeakFoldDescription":
    "Low pairs (22-55) and weak offsuit hands always fold",
  "addLock.templateSuitedCallName": "Suited Connectors Always Call",
  "addLock.templateSuitedCallDescription":
    "Mid suited connectors (76s-JTs) always call/check",
  "addLock.templateNoFoldName": "Remove Folding",
  "addLock.templateNoFoldDescription":
    "Eliminate fold option (forces call or raise)",
  "addLock.templateNoRaiseName": "Remove Raising",
  "addLock.templateNoRaiseDescription":
    "Eliminate raise option (forces fold or call)",
  "addLock.templateAllInFoldName": "All-in or Fold Only",
  "addLock.templateAllInFoldDescription":
    "Remove call/check option (forces fold or raise)",
  "addLock.templateTightRangeName": "Tight Range (15%)",
  "addLock.templateTightRangeDescription":
    "Premium hands only: high pairs, AK, AQ",
  "addLock.templateStandardRangeName": "Standard Opening Range (20%)",
  "addLock.templateStandardRangeDescription": "Typical button opening range",
  "addLock.templateWideRangeName": "Wide Range (35%)",
  "addLock.templateWideRangeDescription": "Aggressive wide opening range",
  "addLock.templatePremiumRangeName": "Premium Range (5%)",
  "addLock.templatePremiumRangeDescription": "Ultra-premium hands: AA, KK, AK",
  "addLock.templatePairsName": "Pocket Pairs Only",
  "addLock.templatePairsDescription": "All pocket pairs from 22 to AA",
  "addLock.templateBroadwayName": "Broadway Hands",
  "addLock.templateBroadwayDescription": "High card combinations (T+)",
  "aiSetup.quickSetup": "Quick Setup",
  "aiSetup.quickSetupWithImage":
    "Parse the screenshot, or remove it to start from a sample hand.",
  "aiSetup.quickSetupWithoutImage":
    "Drop a table screenshot or start from a sample hand.",
  "aiSetup.dropScreenshot": "Drop a screenshot here",
  "aiSetup.or": "or",
  "aiSetup.uploadScreenshot": "Upload a table screenshot",
  "aiSetup.chooseImage": "Choose Image",
  "aiSetup.imageFormatHelp":
    "PNG or JPG from any poker client · parsed with AI",
  "aiSetup.noScreenshot": "No screenshot?",
  "aiSetup.textOrSampleHelp":
    "Paste OHH JSON or Bracketed Text in step 2, or load a sample hand.",
  "aiSetup.loadSample": "Load Sample Hand",
  "aiSetup.replace": "Replace",
  "aiSetup.remove": "Remove",
  "aiSetup.parsing": "Parsing...",
  "aiSetup.parseImage": "Parse Image",
  "aiSetup.previewAlt": "Preview",
  "aiSetup.handHistory": "Hand History",
  "aiSetup.reviewParsedHand":
    "Review the parsed hand and fix anything the AI missed before it reaches the solver.",
  "aiSetup.importHandHelp":
    "Paste OHH JSON or Bracketed Text here, or import a hand in step 1.",
  "aiSetup.handHistoryView": "Hand history view",
  "aiSetup.textView": "Text",
  "aiSetup.uiView": "UI View",
  "aiSetup.pokerStarsViewHelp": "Hand history text in the PokerStars format",
  "aiSetup.copy": "Copy",
  "aiSetup.copied": "Copied!",
  "aiSetup.copyFailed": "Failed",
  "aiSetup.download": "Download",
  "aiSetup.cardMismatchTitle":
    "Cards in the Card Positions panel differ from Hand History",
  "aiSetup.cardsOnlyInImage": "Only in the image: {cards}",
  "aiSetup.cardsOnlyInHandHistory": "Only in Hand History: {cards}",
  "aiSetup.cardMismatchHelp":
    "Fix the cards in the JSON from the Text view, or add the missing box in the Card Positions panel.",
  "aiSetup.openTextView": "Switch to Text View",
  "aiSetup.editorPlaceholder":
    "Paste OHH JSON or Bracketed Text hand history...",
  "aiSetup.prettifyJson": "Prettify JSON",
  "aiSetup.convertedBeforeValidation":
    "{format} was converted to OHH JSON before validation.",
  "aiSetup.forPlayers": "for: {players}",
  "aiSetup.viewOriginal": "View Source",
  "aiSetup.applyToSolver": "Apply to Solver",
  "aiSetup.applyDescription":
    "Sets the board, preflop-derived ranges, pot and effective stacks on the solver.",
  "aiSetup.simplifyRanges":
    "Simplify to practical frequencies (0%, 25%, 50%, 75%, 100%)",
  "aiSetup.simplifyRangesHelp":
    "Easier to execute at the table. Raw frequencies are more precise but take longer to solve.",
  "aiSetup.addHandFirst": "Add a hand history in step 2 first.",
  "aiSetup.solving": "Solving...",
  "aiSetup.applyConfig": "Apply Config",
  "aiSetup.iterationProgress": "Iteration {current} / {target}",
  "aiSetup.exploitabilityShort": "(expl: {value})",
  "aiSetup.solveProgress": "Solve progress",
  "aiSetup.preflopOnlyTitle": "Preflop-Only Hand Detected",
  "aiSetup.preflopOnlyHelp":
    'When you click "Apply Config", this hand will be analyzed for preflop actions only. Solver configuration is not available for hands that end preflop.',
  "aiSetup.chips": "chips",
  "aiSetup.jsonFormatError": "JSON format error: the text is not valid JSON.",
  "aiSetup.imageOnly": "Only image files (PNG, JPG) can be parsed.",
  "aiSetup.parsingImage": "Parsing image with AI...",
  "aiSetup.imageParsed":
    "Image parsed successfully! Review the hand history JSON and click 'Apply Config'.",
  "aiSetup.imageParseFailed": "Failed to parse image",
  "aiSetup.unexpectedError": "An unexpected error occurred",
  "aiSetup.unknownError": "Unknown error",
  "aiSetup.unknownStringError": "Unknown string error",
  "aiSetup.unknownObjectError": "Unknown object error",
  "aiSetup.errorPrefix": "Error: {message}",
  "aiSetup.sampleLoadFailed":
    "Failed to load the sample: content not found ({filename})",
  "aiSetup.sampleLoaded":
    "Sample hand loaded ({filename}). Review it in step 2, then click Apply Config.",
  "aiSetup.parseFailed": "Failed to parse hand history:\n{detail}",
  "aiSetup.unsupportedFormat":
    "Only OHH JSON and {formats} formats are supported. Paste a supported format or upload an image to parse.",
  "aiSetup.ohhValidationFailed": "OHH validation failed:\n{errors}",
  "aiSetup.unknownParsingError": "Unknown parsing error",
  "aiSetup.unknownStartingStack":
    "Cannot apply config: starting stack is unknown (-1) for {players}. Enter each player's starting_stack in the hand history JSON.",
  "aiSetup.invalidHandState": "Invalid hand state",
  "aiSetup.missingOhh":
    "Could not read the OHH JSON, so the preflop analysis cannot run.",
  "aiSetup.preflopOnlyDetected":
    "Preflop-only hand detected. Showing action timeline below.",
  "aiSetup.preflopAnalysisFailed":
    "Failed to analyze preflop hand. Please check the hand history format.",
  "aiSetup.missingSummary":
    "The OHH hand has no summary, so the config cannot be applied.",
  "aiSetup.rangeLoaded": "(range loaded)",
  "aiSetup.defaultRange": "(default range)",
  "aiSetup.configApplied":
    "Config applied successfully!\nBoard: {board}\nPot: {pot} | Effective Stack: {stack}\nOOP: {oopPosition} {oopRangeStatus}\nIP: {ipPosition} {ipRangeStatus}",
  "aiSetup.rangeQuality": "Range Quality:",
  "aiSetup.defaultBetSizes": "Bet sizes: 33%, 50%, 75% (default)",
  "aiSetup.noMessage": "{name} (no message)",
  "aiSetup.unknownNoMessage": "Unknown error (no message)",
  "aiSetup.editFailed": "Edit failed: {message}",
  "aiSetup.playerNotFound": "Player at seat {seat} not found",
  "aiSetup.normalizedInvalid": "Normalized hand history is not valid OHH JSON.",
  "aiSetup.reachingRangesFailed": "Failed to get reaching ranges: {message}",
  "aiSetup.actionFrequency": " → {action} freq",
  "aiSetup.rangeMetadata":
    "{label}: {player} ({position}){action} - method: {method}",
  "aiSetup.loadRangesFailed": "Failed to load ranges: {message}",
  "results.potValue": "Pot {value}",
  "results.stackValue": "Stack {value}",
  "results.total": "Total",
  "results.linkCopied": "Copied!",
  "results.copyShareLink": "Copy Share Link",
  "results.basics": "Basics",
  "results.graphs": "Graphs",
  "results.compare": "Compare",
  "results.player": "Player:",
  "results.autoPlayer": "Auto ({player})",
  "results.barHeight": "Bar Height:",
  "results.barWidth": "Bar width:",
  "results.normalized": "Normalized",
  "results.absolute": "Absolute",
  "results.full": "Full",
  "results.suit": "Suit:",
  "results.grouped": "Grouped",
  "results.individual": "Individual",
  "results.display": "Display:",
  "results.strategy": "Strategy",
  "results.strategyEq": "Strategy + EQ",
  "results.strategyEv": "Strategy + EV",
  "results.weight": "Weight",
  "results.chart": "Chart:",
  "results.strategyCombos": "Strategy (Combos)",
  "results.strategyPercent": "Strategy (%)",
  "results.equity": "Equity",
  "results.summary": "Summary",
  "results.actionPercent": "Action %",
  "results.actionEv": "Action EV",
  "results.exportSummary": "Export summary to CSV file",
  "results.loadingCachedTree": "Loading cached tree...",
  "results.solverNotRun": "Solver has not run.",
  "results.solverRunning": "Solver running...",
  "results.finalizing": "Finalizing...",
  "results.solverPaused": "Solver paused.",
  "results.treePreview":
    "Tree structure view — solve not started. Strategy data will appear after running the solver.",
  "results.backToSolver": "Back to Solver",
  "results.gtoScore": "GTO Score",
  "sideBar.oopRange": "OOP Range",
  "sideBar.ipRange": "IP Range",
  "sideBar.board": "Board",
  "sideBar.treeConfiguration": "Tree Configuration",
  "sideBar.runSolver": "Run Solver",
  "sideBar.result": "Result",
  "sideBar.about": "About",
  "sideBar.ranges": "Ranges",
  "sideBar.solve": "Solve",
  "sideBar.playerRanges": "Player Ranges",
  "sideBar.solver": "Solver",
  "sideBar.menu": "Menu",
  "aiSetup.annotationsRegions": "Regions",
  "aiSetup.annotationsCards": "Cards",
  "aiSetup.annotationsWords": "Words",
  "aiSetup.annotatedPreview": "Annotated preview",
  "aiSetup.sourceImage": "Source image",
  "aiSetup.extractionResultSummary": "Image regions and extraction summary",
  "aiSetup.viewExtractionResult": "View Extraction Result",
  "aiSetup.hideExtractionResult": "Hide Extraction Result",
  "aiSetup.extractedImageDetails": "Extracted image details",
  "aiSetup.extractionSummary": "Extraction Summary",
  "aiSetup.board": "Board",
  "aiSetup.players": "Players",
  "aiSetup.extractedRegions": "Extracted Regions",
  "aiSetup.noPreflopStrategy": "No preflop strategy loaded",
  "aiSetup.preflopTreeHelp":
    "Apply a hand in AI Setup and its solved preflop tree appears here.",
  "aiSetup.goToAiSetup": "Go to AI Setup",
  "aiSetup.selectTreePosition":
    "Select a position in the tree to view strategy",
  "aiSetup.actions": "Actions",
  "aiSetup.combo": "combo",
  "aiSetup.postflopConfig": "Postflop Config",
  "aiSetup.notSet": "Not set",
  "aiSetup.advanced": "Advanced",
  "aiSetup.pot": "Pot",
  "aiSetup.stack": "Stack",
  "aiSetup.editSettings": "Edit Settings",
  "aiSetup.continueToSolver": "Continue to Solver",
  "aiSetup.selectPosition": "Select a position",
  "aiSetup.positionStrategy": "{position} Strategy",
  "aiSetup.workflowLabel": "AI setup workflow",
  "aiSetup.workflow": "Workflow",
  "aiSetup.strategyLoaded": "Strategy loaded",
  "aiSetup.setup": "Setup",
  "aiSetup.solve": "Solve",
  "aiSetup.preflopActionTree": "Preflop Action Tree",
  "aiSetup.revert": "Revert",
  "aiSetup.pokerStarsTextLabel": "PokerStars hand history text",
  "aiSetup.lineIssue": "Line {line}: ",
  "aiSetup.pokerStarsCopied": "Copied PokerStars text to the clipboard.",
  "aiSetup.pokerStarsCopyFailed": "Could not copy the PokerStars text.",
  "aiSetup.resetBoxes": "Reset",
  "aiSetup.pokerStarsEditFailed":
    "Could not apply the edit · fix the line issues below",
  "aiSetup.pokerStarsShownInBbExportChips":
    "Shown in BB, Copy and Download use chips · edits apply immediately",
  "aiSetup.pokerStarsShownInBb": "Shown in BB · edits apply immediately",
  "aiSetup.ruleErrorsTitle": "Hand rule errors: {count}",
  "aiSetup.pokerStarsExportBlockedByRuleErrors":
    "Fix the hand rule errors to export.",
  "aiSetup.pokerStarsExportIssue":
    "{message}. The text on screen is in BB for display and differs from the original chip amounts.",
  "aiSetup.pokerStarsExportsChips": "Exports PokerStars text in chip units",
  "aiSetup.pokerStarsExports": "Exports PokerStars text",
  "aiSetup.pokerStarsEditing":
    "Editing · applies to the hand when you stop typing",
  "aiSetup.pokerStarsReady": "Edits apply immediately",
  "aiSetup.pokerStarsUnsupported":
    "Only OHH JSON and supported dialect text can be converted.",
  "aiSetup.pokerStarsParseFailed": "Failed to parse hand history: {detail}",
  "aiSetup.pokerStarsInvalidOhh": "Invalid OHH JSON: {detail}",
  "aiSetup.pokerStarsConversionFailed":
    "Cannot convert to PokerStars text: {detail}",
  "aiSetup.reviewCardPositions": "Review Card Positions",
  "aiSetup.cardPositionReview": "Card Positions",
  "aiSetup.collapse": "Collapse",
  "aiSetup.cardPositionImage": "Card review image",
  "aiSetup.addBoxInstruction": "Adding a box — drag around the card",
  "aiSetup.done": "Done",
  "aiSetup.aiPrediction": "AI-detected",
  "aiSetup.userEdited": "Your edits",
  "aiSetup.unassignedCard": "No card assigned",
  "aiSetup.aspectMismatch":
    "The image aspect ratio differs from the detection result, so auto-detection cannot be used. Mark the visible cards yourself.",
  "aiSetup.noDetectionResult":
    "No auto-detection result. Mark the visible cards yourself.",
  "aiSetup.noCardsDetected": "No cards detected",
  "aiSetup.addingBox": "Adding Box",
  "aiSetup.addBox": "Add Box",
  "aiSetup.undo": "Undo",
  "aiSetup.resetToPrediction": "Reset to AI Prediction",
  "aiSetup.resetPredictionLabel": "Confirm reset to AI prediction",
  "aiSetup.resetPredictionConfirm":
    "Reset to the AI prediction? You can undo this.",
  "aiSetup.unassigned": "unassigned",
  "aiSetup.selectCardBox": "Select the {card} card box",
  "aiSetup.changeCard": "Change Card",
  "aiSetup.missingCardHelp":
    "The AI may have missed some cards. Check the whole screen and add a box for any missing card.",
  "aiSetup.submitting": "Submitting...",
  "aiSetup.submitTrainingData": "Submit as Training Data",
  "aiSetup.tryAgain": "Retry",
  "aiSetup.noDetectionSummary":
    "No auto-detection result · marking the card positions helps improve card recognition",
  "aiSetup.detectionSummary":
    "Detected cards: {count} · confirming them helps improve card recognition",
  "aiSetup.confirmNoCards": "Confirmed that this image shows no cards",
  "aiSetup.confirmAllCards":
    "Marked every visible card with a box and confirmed the cards",
  "aiSetup.unassignedCount": "Boxes without a card: {count}",
  "aiSetup.tooSmallCount": "Boxes too small: {count}",
  "aiSetup.duplicateCount": "Overlapping box pairs: {count}",
  "aiSetup.tooManyBoxes": "Up to 64 boxes",
  "aiSetup.invalidBoxes":
    "Box data is invalid — reset and mark the cards again",
  "aiSetup.submissionSuccess":
    "Submitted. Submitting again after edits replaces it with the latest version.",
  "aiSetup.submissionStale": "Edited after submission — submit again",
  "aiSetup.submissionFailed": "Submission failed. Your edits are still here.",
  "aiSetup.handHistoryUpdated": "Applied to Hand History: {summary}",
  "aiSetup.handHistoryReverted": "Reverted in Hand History: {summary}",
  "dbItemPicker.noSavedRanges": "(No saved ranges)",
  "dbItemPicker.noSavedConfigurations": "(No saved configurations)",
  "dbItemPicker.emptyGroup": "(Empty group)",
  "dbItemPicker.loadError": "Something went wrong. Please reload the page.",
  "dbItemPicker.load": "Load",
  "dbItemPicker.overwrite": "Overwrite",
  "dbItemPicker.rename": "Rename",
  "dbItemPicker.addGroup": "Add Group",
  "dbItemPicker.importJson": "Import JSON",
  "dbItemPicker.exportJson": "Export JSON",
  "dbItemPicker.importFailed": "Error: Import failed.",
  "dbItemPicker.newGroup": "New group",
  "dbItemPicker.newRange": "New range",
  "dbItemPicker.newConfiguration": "New configuration",
  "dbItemPicker.groupConflict":
    'Cannot create group "{name}" because the item already exists',
  "login.tagline": "GTO Poker Solver for",
  "login.seriousPlayers": "serious players",
  "login.postflopSolver": "Postflop Solver",
  "login.preflopSolutions": "Preflop Solutions",
  "login.createAccount": "Create Account",
  "login.signIn": "Sign In",
  "login.signUpGoogle": "Sign up with Google",
  "login.continueGoogle": "Continue with Google",
  "login.signUpApple": "Sign up with Apple",
  "login.continueApple": "Continue with Apple",
  "login.oauthHelp":
    "OAuth creates your account through Google or Apple and does not set a Locktree password.",
  "login.createWithEmail": "or create with email and password",
  "login.signInWithEmail": "or sign in with email",
  "login.email": "Email",
  "login.emailPlaceholder": "you@example.com",
  "login.password": "Password",
  "login.confirmPassword": "Confirm Password",
  "login.confirmPasswordPlaceholder": "Confirm your password",
  "login.resendVerification": "Resend verification email",
  "login.processing": "Processing...",
  "login.haveAccount": "Already have an account? Sign In",
  "login.needAccount": "Don't have an account? Create one",
  "login.passwordMismatch": "Passwords do not match",
  "login.passwordRequirements": "Password does not meet requirements",
  "login.accountCreated":
    "Account created successfully! Check your email before signing in.",
  "login.verificationSent": "Verification email sent.",
  "history.title": "Solve History",
  "history.loading": "Loading history...",
  "history.signInHelp": "Sign in to view your solve history",
  "history.empty": "No solve history yet",
  "history.emptyHelp":
    "Your solved trees will appear here after you run the solver",
  "history.invalidEntries.one": "{count} invalid entry found",
  "history.invalidEntries.other": "{count} invalid entries found",
  "history.invalidHelp":
    "These entries have missing or corrupted data from before bug fixes",
  "history.deleteAllInvalid": "Delete All Invalid",
  "history.unnamed": "Unnamed",
  "history.invalidData": "INVALID DATA",
  "history.configOnly": "Config only",
  "history.loadingConfig": "Loading config...",
  "history.noBoard": "No board",
  "history.exploitability": "Exploitability: {value}",
  "history.iterations": "Iterations: {value}",
  "history.manual": "Manual",
  "history.loadMore": "Load more ({shown} / {total})",
  "history.deleteEntry": "Delete Entry?",
  "history.deleteConfirm": 'Are you sure you want to delete "{name}"?',
  "history.deleteInvalidConfirm":
    "Delete {count} invalid entries? This cannot be undone.",
  "history.deleteSomeFailed":
    "Failed to delete some entries. Please try again.",
  "history.loadFailed": "Failed to load history",
  "history.configLoaded":
    "The previous settings were loaded. Check the Board and Range, then run the solver again.",
  "history.configLoadFailed":
    "Could not load the settings. Please try again shortly.",
  "handHistory.handNumber": "Hand #{id}",
  "handHistory.ante": "Ante:",
  "handHistory.players": "Players",
  "handHistory.stack": "Stack",
  "handHistory.board": "Board:",
  "handHistory.actionAmount": "Action amount in {unit}",
  "handHistory.deleteAction": "Delete action",
  "handHistory.addAction": "+ Add Action",
  "handHistory.summary": "Summary",
  "handHistory.totalPot": "Total Pot:",
  "handHistory.finalBoard": "Final Board:",
  "handHistory.unavailable": "No hand history available",
  "handHistory.allIn": "All-in",
  "handHistory.noLimit": "No Limit",
  "handHistory.potLimit": "Pot Limit",
  "handHistory.fixedLimit": "Fixed Limit",
  "handHistory.unspecified": "Unspecified",
  "handHistory.street": "Street {street}",
  "handHistory.unknown": "Unknown",
  "handHistory.postsSb": "Posts SB",
  "handHistory.postsBb": "Posts BB",
  "handHistory.postsAnte": "Posts Ante",
  "handHistory.folds": "Folds",
  "handHistory.checks": "Checks",
  "handHistory.calls": "Calls",
  "handHistory.bets": "Bets",
  "handHistory.raises": "Raises",
  "handHistory.shows": "Shows",
  "handHistory.mucks": "Mucks",
  "handHistory.collected": "Collected",
  "handHistory.doesNotShow": "Doesn't show",
  "handHistory.sampleTitle": "Choose a Sample Hand",
  "handHistory.imageUnavailable": "Image not available",
  "score.title": "GTO Score Analysis",
  "score.decisionsAnalyzed": "{count} decisions analyzed",
  "score.totalEvLoss": "Total EV Loss: -{value}bb",
  "score.hero": "Hero:",
  "score.points": "{points}pts",
  "score.experience": "Try It",
  "score.noDecisions": "No hero decisions to analyze",
  "score.calculating": "Calculating GTO score...",
  "score.noHandHistory": "No hand history available for analysis",
  "spot.evLoss": "EV Loss -{value} BB",
  "spot.analyzing": "Analyzing...",
  "spot.actualOpponentHand": "Opponent's Actual Hand",
  "spot.opponentRange": "Opponent Range Distribution",
  "spot.value": "Value",
  "spot.semiBluff": "Semi-bluff",
  "spot.bluff": "Bluff",
  "spot.gtoAnswer": "GTO Answer",
  "spot.choiceFrequency":
    "Your choice ({action}) has a GTO frequency of {frequency}%",
  "spot.selectedActionEv": "Selected Action EV",
  "spot.bestActionEv": "Best Action EV",
  "spot.retryCount": "Retried {count} times",
  "spot.retrySame": "Try the Same Spot Again",
  "spot.noUploadedHand": "No uploaded hand history is available.",
  "spot.analysisFailed": "Analysis failed.",
  "spot.retryFailed": "Retry failed.",
  "spot.networkError": "Network error",
  "spot.error": "Error: {message}",
  "results.graphsUnavailable": "Graphs not available",
  "results.wins": "{player} Wins",
  "preflopTree.actualPlay": "Actual play",
  "preflopTree.postflopStarts": "Postflop starts",
  "preflopTree.headsUpOnly": "Only heads-up postflop solve is supported",
  "preflopTree.terminalHeader": "END",
  "preflopTree.flopHeader": "FLOP",
  "preflopTree.turnHeader": "TURN",
  "preflopTree.riverHeader": "RIVER",
  "preflopTree.flopBoard": "Flop Board",
  "preflopTree.cardPlaceholder": "e.g. 9s",
  "preflopTree.running": "Running...",
  "preflopTree.runPostflop": "Run Postflop Solve",
  "preflopTree.actionTree": "Action Tree",
  "preflopTree.selectNode": "Select a node to view its range",
  "preflopTree.handEnds": "Hand ends",
  "preflopTree.enterThreeCards": "Enter all three cards.",
  "preflopTree.invalidCard": 'The {position} card is invalid: "{card}"',
  "preflopTree.first": "first",
  "preflopTree.second": "second",
  "preflopTree.third": "third",
  "preflopTree.duplicateCards": "There are duplicate cards.",
  "preflopTree.reachingRangesMissing":
    "Reaching ranges are unavailable. Complete the preflop solve first.",
  "preflopTree.resultIdMissing":
    "The postflop solve returned no result identifier, so the result cannot be loaded.",
  "preflopTree.runFailed": "Failed to run postflop solve",
  "preflopSettings.change": "Change",
  "preflopSettings.format": "Format",
  "preflopSettings.formatCash": "CASH",
  "preflopSettings.formatMtt": "MTT",
  "preflopSettings.anteBigBlind": "BB ante 1bb",
  "preflopSettings.antePerSeat": "Ante 0.125bb/seat",
  "preflopSettings.ante": "Ante",
  "preflopSettings.players": "Players",
  "preflopSettings.stack": "Stack (BB)",
  "preflopSettings.solve": "Solve",
  "preflopSolution.root": "Root",
  "preflopSolution.exploitabilityShort": "expl: {value}",
  "preflopSolution.exploitability": "Exploitability: {value}",
  "preflopSolution.cacheTime": "Cache saved at: {value}",
  "preflopSolution.cache": "Cache: {value}",
  "preflopSolution.unavailable": "Precomputed strategy unavailable",
  "preflopSolution.unavailableHelp":
    "This preflop spot has not been precomputed yet. Choose another setup or try again after the next precompute batch.",
  "preflopStrategy.solveToView": "Solve to view strategy",
  "preflopStrategy.combos": "{count} combo",
  "preflopStrategy.comingSoon": "Coming soon",
  "preflopStrategy.strategy": "Strategy",
  "preflopStrategy.range": "Range",
  "preflopStrategy.analysis": "Analysis",
  "preflopStrategy.report": "Report",
  "preflopOverview.potOdds": "Pot Odds:",
  "preflopOverview.actions": "Actions",
  "preflopOverview.filterByAction": "Filter by action",
  "preflopOverview.minimumFrequency": "Minimum frequency: {frequency}%",
  "preflopOverview.handCount.one": "{count} hand",
  "preflopOverview.handCount.other": "{count} hands",
  "preflopOverview.handsMatching": "{count} hands matching",
  "preflopOverview.blockerHelp":
    "Blocker analysis requires postflop context. Select a postflop spot to view blocker effects.",
  "preflopOverview.solveToView": "Solve to view overview",
  "preflopOverview.hand": "Hand",
  "preflopOverview.solveToViewTable": "Solve to view table",
  "preflopOverview.equityDistribution":
    "Equity distribution by action for {position}",
  "preflopOverview.combo": "combo",
  "preflopOverview.solveToViewEquity": "Solve to view equity chart",
  "preflopOverview.overview": "Overview",
  "preflopOverview.table": "Table",
  "preflopOverview.equityChart": "Equity Chart",
  "preflopOverview.summary": "Summary",
  "preflopOverview.filter": "Filter",
  "preflopOverview.blocker": "Blocker",
  "preflopOverview.actionEv": "EV by action (bb)",
  "trace.recordedNev": "Recorded NEV to hero (action)",
  "trace.terminalPath": "Terminal path",
  "trace.neutralFallback":
    "This path used a neutral fallback. Do not interpret the equity actually used as measured raw equity.",
  "trace.legacyFallback":
    "This is a previous-generation artifact. Its training policy skipped multiway equity calculations with 7 or more players and used a neutral fallback (1/N). Do not interpret the equity actually used as measured raw equity.",
  "trace.unrecordedDecomposition":
    "This calculation path recorded only the final EV. Opponent-level equity decomposition was not recorded.",
  "trace.threeWayHelp":
    "This is a 3-way conditional average. Each row fixes opponent 1's hand and aggregates opponent 2's range. The share is normalized from all three players' equity × ERW for each tuple; it is neither HU win rate nor a ratio of only two ERWs. The valid-combos column shows combo mass including opponent 2's reach. Per-tuple denominators were not recorded, so individual denominators cannot be verified from this table alone.",
  "trace.hand169Help":
    "These are Hand169 classes, not concrete suit combos. Select an opponent hand to filter the table.",
  "trace.terminalTableCaption":
    "Raw equity, ERW, normalized share, and hero value contribution by opponent hand",
  "trace.reach": "Reach",
  "trace.reachValue": "reach {value}",
  "trace.depthValue": "depth {depth}",
  "trace.rawEquity": "Raw equity",
  "trace.potShare": "Pot share",
  "trace.terminalContribution": "Terminal internal contribution bb",
  "trace.sidePotHelp":
    "This is the existing range aggregation by side pot. It sums all gross values, then subtracts contribution and ante once.",
  "trace.pot": "Pot",
  "trace.providerStatus": "Provider status",
  "trace.usedEquity": "Used equity",
  "trace.grossBb": "Gross bb",
  "trace.seatHandPot": "Seat · Hand · Pot",
  "trace.usedPositionRank": "Position rank used",
  "trace.ruleBasedHelp":
    "Suited & connector adjustment × position effect × aggressor range effect = ERW before premium adjustment (B). ERW before SPR adjustment (E) = B + (1.09482872 − B) × premium recovery strength, where 1.09482872 is this model's upper bound when the most IP seat is also the last aggressor. Premium recovery strength is a per-hand grade; the value in the table is the one actually used for this call. Do not compare it with a documented grade table because it can differ by coefficient generation. SPR recovery strength = 1 / (1 + (SPR / 1.5)^2.5). Final ERW = E + (1 − E) × SPR recovery strength.",
  "trace.offsetHelpBeforeFormula":
    "The measured-path value is a per-seat realization offset (pot fraction). It is solved to reproduce, over the measured range's marginals, how much more (+) or less (−) pot this hand captured than showdown equity on the same board in the measured postflop solve. It does not use the rule-based synthesis (multiplication, premium, SPR recovery) or pot-growth transform. Deal share is",
  "trace.offsetHelpAfterFormula":
    "where e is the deal's physical equity and δ is each seat's realization offset; a share below 0 is a loss from additional postflop investment.",
  "trace.offsetFormulaSuffix": "is used to determine it —",
  "trace.erwCaution":
    "The aggressor range effect approximates from whether the seat was the last aggressor. Rule-based ERW is a multiplier, while the measured-path value is a pot-fraction offset; either way, this is the value recorded for the current call. Recording a calculated value does not guarantee it affected the payoff. Check the provider status as well.",
  "trace.opponentSeatPot": "Opponent seat · Pot",
  "trace.poolingHelp":
    "Z = included mass, B = Σ(mass × used equity), A = Σ(mass × used equity × ERW). Σ(A/Z) ÷ Σ(B/Z) across included seats is the opponents' average ERW. Exclusion statuses such as DeadReach remain in the inputs below.",
  "trace.root": "root",
  "trace.actingSeatHidden":
    "Based on the acting seat — hidden because this is not this hand's perspective",
  "trace.firstIteration": "Go to first iteration",
  "trace.previousIteration": "Go to previous iteration",
  "trace.nextIteration": "Go to next iteration",
  "trace.lastIteration": "Go to last iteration",
  "trace.searchPlaceholder":
    "Search position / action / node_key — e.g. UTG+2, allin, r22r52",
  "trace.explorerTitle": "CFR Node Explorer",
  "trace.runSummary":
    "{players} players · capture {nodes} · {hands} · {interval}",
  "trace.noLocation":
    "No trace is selected. Select a hand on the preflop solution screen, then open its learning trace to enter this screen.",
  "trace.hand": "Hand",
  "trace.first": "First",
  "trace.previous": "Previous",
  "trace.iteration": "iteration {iteration}",
  "trace.perspective": "perspective",
  "trace.next": "Next",
  "trace.last": "Last",
  "trace.learningTurnNotice":
    "{iterationSeat} trained in this iteration — {actingSeat} was not updated in this iteration.",
  "trace.previousLearning": "← Previous {seat} training iteration",
  "trace.nextLearning": "Next {seat} training iteration →",
  "trace.expandDepth": "Through depth {depth}",
  "trace.expandAll": "Expand all",
  "trace.collapseAll": "Collapse all",
  "trace.followWorstPath": "Follow loss path",
  "trace.rowCount": "Trace {visible} / {total} rows",
  "trace.refreshing": "Refreshing…",
  "trace.nodeTitle": "Go to {seat} node",
  "trace.uncaptured": "Outside capture range (no value for this iteration)",
  "trace.toggle": "Collapse or expand",
  "trace.evidenceAria":
    "View the calculation evidence for {action}'s hero value",
  "trace.evidence": "Evidence",
  "trace.allHands": "All hands",
  "trace.heroTraining": "hero training",
  "trace.round": "iteration",
  "trace.every": "Every {count} {unit}",
  "trace.allIntervals": "All {unit}",
  "trace.noTraceForGame": "This game has no learning trace",
  "trace.loadingTrace": "Loading learning trace…",
  "trace.loadTraceFailed": "Could not load the learning trace.",
  "trace.selectHandFirst": "Select a hand first",
  "trace.notCaptured": "This point was not recorded for this hand",
  "trace.columnTreePosition": "Node/action information",
  "trace.columnLearningInput": "Learning data",
  "trace.columnLearningApplied": "After learning",
  "trace.stageLearningInput":
    "Value that produced this iteration's learning (learning data)",
  "trace.stageLearningApplied":
    "Value after this iteration's learning was applied (after learning)",
  "trace.columnTooltipStage": "{description} — {stage}",
  "trace.columnAction": "Action (position)",
  "trace.columnDepth": "depth",
  "trace.columnRegret": "regret",
  "trace.columnActionHelp":
    "One action branching from the node and the position taking it. Indentation is depth.",
  "trace.columnDepthHelp":
    "The number of actions already taken from the root to the node where this edge starts. This is absolute depth from the root, not from the node being viewed.",
  "trace.columnRegretBefore": "regret sum (before)",
  "trace.columnRegretBeforeHelp":
    "Cumulative regret this action already had when the iteration began. It was accumulated through the previous iteration, not created by this traversal. The positive portion produced this seat's action probability for this iteration. This is derived by reversing regret sum (after) − regret. It is hidden on opponent action rows because it describes the acting seat holding this row's Hand169 class and is not representative when following this hand.",
  "trace.columnReachHelp":
    "The probability that the row's reference player reaches this point.",
  "trace.columnNodeNev": "NEV to hero (node)",
  "trace.columnNodeNevHelp":
    "The expected value (bb) this hand receives at the node, mixing child action values with that iteration's strategy. The reference is hero even at a node where an opponent acts.",
  "trace.columnActionNev": "NEV to hero (action)",
  "trace.columnActionNevHelp":
    "The expected value (bb) returned to the hero hand when this action occurs. The actor may be hero or an opponent, but the value always belongs to hero. On decision rows where hero acts, the difference from NEV to hero (node) accumulates as regret. This relationship does not hold on opponent_branch rows because regret for that iteration is always 0 there.",
  "trace.columnContribution": "Contribution (bb)",
  "trace.columnContributionHelp":
    "Reach probability from the root through this edge × NEV to hero (action). Summing every child contribution of a node produces the node value.",
  "trace.columnRegretHelp":
    "The value this iteration added to regret sum. On decision rows, the CFR variant calculates it from NEV to hero (action) − NEV to hero (node). It is hidden on opponent action rows because it is based on the acting seat and is always 0 when that seat is not the learner for this iteration, which can be mistaken for this hand having zero regret.",
  "trace.columnRegretAfter": "regret sum (after)",
  "trace.columnRegretAfterHelp":
    "Cumulative regret including this iteration's learning. The seat's next action probabilities are determined by its positive portion. It is hidden on opponent action rows because it describes the acting seat holding this row's Hand169 class and is not representative when following this hand.",
  "trace.columnNextStrategy": "Next action probability",
  "trace.columnNextStrategyHelp":
    "The seat's next-iteration action probability calculated from the positive portion of cumulative regret (regret matching). If all values are non-positive, actions are distributed uniformly. It is hidden on opponent action rows because it is based on the acting seat.",
  "trace.columnAverageStrategy": "Average action probability",
  "trace.columnAverageStrategyHelp":
    "The cumulative average of the seat's per-iteration action probabilities, which is what CFR converges toward and what the range grid displays. The percentage beside an action on a hero decision row is the current probability for that iteration, so it normally differs from this average. On an opponent action row, that percentage is the full-range branch weight and is not comparable. This column is hidden there because it is based on the acting seat.",
  "trace.legendPathHelp":
    "The path taken to this node. It expands action_history, has no value for that iteration, and opens the node when selected. Raise sizes are truncated to 0.1bb when stored, so they are lower bounds: if an edge says raise_2.25 and the path says raise_2.2, that is all the precision retained there.",
  "trace.legendOpponentNode": "Opponent node",
  "trace.legendOpponentNodeHelp":
    "A row for a node where an opponent acts — the value this hand receives when the opponent takes that action. Only hero-based value columns are shown: the percentage beside the action, NEV to hero, and contribution (bb) are branch weights across the opponent's entire range conditional on this hand, so they are what this hand actually encounters. Acting-seat columns are hidden because they are one Hand169 slice of that seat's learning state and are not representative for a screen following one hero hand. The exact snapshot remains in the API response.",
  "trace.uncalculated": "Not calculated",
  "trace.unrecorded": "Not recorded",
  "trace.unused": "Unused",
  "trace.yes": "Yes",
  "trace.no": "No",
  "trace.wholePot": "Whole pot",
  "trace.potNumber": "Pot {number}",
  "trace.erwEvidenceCount": "ERW calculation evidence · {count}",
  "trace.noErwEvidence":
    "ERW calculation evidence was not recorded. New evidence requires a new trace produced with observation enabled.",
  "trace.erwSkipped": "ERW calculation skipped — {reason}",
  "trace.reasonUnrecorded": "Reason not recorded",
  "trace.activeSeats": "Active seats",
  "trace.effectiveStackBb": "Effective stack bb",
  "trace.suited": "Suited",
  "trace.premium": "Premium classification",
  "trace.lastAggressor": "Last aggressor",
  "trace.noneOrUnrecorded": "None or not recorded",
  "trace.notLastAggressor": "Not the last aggressor",
  "trace.rankHelp":
    "rank is the value actually used in the calculation (0 = most OOP). It is not a recalculation of the correct poker position order.",
  "trace.factorSuitedConnector": "Suited & connector adjustment",
  "trace.factorPosition": "Position effect",
  "trace.factorAggressorRange": "Aggressor range effect",
  "trace.factorBeforePremium": "ERW before premium adjustment",
  "trace.factorPremiumRecovery": "Premium recovery strength",
  "trace.factorBeforeSpr": "ERW before SPR adjustment",
  "trace.factorSprRecovery": "SPR recovery strength",
  "trace.realizationOffset": "Realization offset (pot fraction)",
  "trace.finalErw": "Final ERW",
  "trace.actionNevAria": "NEV to hero calculation evidence",
  "trace.nevToHero": "NEV to hero",
  "trace.heroValue": "hero value",
  "trace.heroValueAria": "hero value calculation evidence",
  "trace.actionEvidenceTitle":
    "{seat} · {hand} · {action} {value} calculation evidence",
  "trace.evidenceContext":
    "iteration {iteration} · {history} · All EV values are from the selected hero's perspective.",
  "trace.zeroProbabilityHelp":
    "A 0% action probability is different from evaluation being skipped. An unpruned action can have its conditional EV calculated even at 0%. The values below are observations from the selected iteration and do not explain the full learning history of the final average strategy.",
  "trace.loadingEvidence": "Loading EV calculation evidence…",
  "trace.loadEvidenceFailed": "Could not load EV calculation evidence.",
  "trace.verifiedContribution": "Verified child contribution sum{suffix}",
  "trace.terminalGrossSuffix": " (terminal gross EV)",
  "trace.recordedDifference": "Difference (recorded NEV − sum)",
  "trace.frameMismatch": "Frame mismatch — cannot compare",
  "trace.missingPaths": "Missing paths",
  "trace.foldComparison":
    "NEV versus fold at the same node: {value} bb. EV includes prior investment, so fold itself can have negative EV.",
  "trace.reconciliationSummary":
    "{mismatches} local mismatches · {unchecked} nodes could not be checked · {pruned} evaluations skipped",
  "trace.reconciliationHelp":
    "Compares recorded nodes with child EVs. Local differences can remain even when the total difference is zero because they cancel each other. Missing paths cannot be verified.",
  "trace.reconciliationCaption": "Local EV mismatches by node",
  "trace.path": "Path",
  "trace.check": "Check",
  "trace.recordedEv": "Recorded EV",
  "trace.reconstructedEv": "Recombined/child EV",
  "trace.differenceBb": "Difference bb",
  "trace.nodeSum": "Node sum",
  "trace.childLink": "Child link",
  "trace.missingEvidence":
    "Some or all calculation evidence was not recorded. Older traces do not contain this information. Do not interpret a missing path as EV 0.",
  "trace.terminalOption":
    "{history} · weight {weight} · contribution {contribution} bb",
  "trace.calculationStatus":
    "Calculation status: {status} · provider status {provider} · actual equity used {equity}",
  "trace.evaluationSkipped":
    "Evaluation skipped ({reason}) · traversal return {value} bb",
  "trace.evaluated": "Evaluated",
  "trace.evaluationUnrecorded": "Evaluation status not recorded",
  "trace.deadReach": "DeadReach returned 0.",
  "trace.impossibleJointDeal":
    "An impossible joint deal used the neutral 1/N value.",
  "trace.erwNotApplied":
    "The recorded ERW calculation was not applied to this payoff.",
  "trace.terminalFormula":
    "{method} · pot {pot} − contribution {contribution} − ante {ante}",
  "trace.equityFlow":
    "Raw equity {rawEquity} → final pot share {potShare} → terminal EV {terminalEv} bb",
  "trace.cacheSource":
    "Cache source record: iteration {iteration} · {history} · key {key}. Linked the source measurement with identical inputs without recalculation.",
  "trace.usedEquityLabel": "Used equity",
  "trace.rawEquityLabel": "Raw equity",
  "trace.equityDifference":
    "Difference from {equityLabel} to final pot share: {value} bb. This difference includes {source}. It is not a retrained result with that term removed.",
  "trace.heroRealizationOffset": "Hero realization offset (pot fraction)",
  "trace.heroErw": "Hero ERW",
  "trace.offsetDifference": "the realization-offset difference",
  "trace.erwNormalization": "ERW and normalization",
  "trace.opponentHandInputs": "Per-hand calculation inputs for opponent {seat}",
  "trace.expandHandMatrix": "Expand 169-hand matrix",
  "trace.showAllOpponentHands": "Show all opponent hands",
  "trace.opponentHand": "Opponent hand",
  "trace.validCombos": "Valid combos",
  "trace.weight": "Weight",
  "trace.opponentValue": "Opponent {value}",
  "trace.amountBb": "Amount bb",
  "trace.calculationPath": "Calculation path",
  "trace.opponentsAverageErw": "Opponents' average ERW",
  "trace.cacheHitMissing":
    "Cache hit: key {key}. The source calculation was not recorded in this artifact, so opponent-hand decomposition is unavailable. It is not recalculated.",
  "trace.nwayAggregate":
    "N-way range aggregation path: hero ERW {heroErw}, opponents' average ERW {opponentsErw}, effective stack {stack}bb, SPR {spr}. The existing calculation has no EV by opponent hand tuple, so no arbitrary pair table is created.",
  "trace.poolingTitle": "Opponents' average ERW aggregation inputs",
  "trace.totalMass": "Total mass",
  "trace.finalAggregation": "Final aggregation: {status}",
  "trace.included": "Included",
  "trace.excluded": "Excluded",
  "trace.poolingCaption":
    "Actual per-hand calculation inputs for opponents' average ERW",
  "trace.mass": "Mass",
  "trace.offsetFormula": "clamp(e + δ_hero − δ_opponent, −SPR, 1 + SPR)",
  "trace.openLearningTrace": "View learning trace",
  "trace.caseMatchSource":
    "This trace was recorded by another solve with the same player count and stack.",
  "trace.solutionHasNoTrace": "This solution did not produce a trace",
  "trace.noNodeToOpen": "There is no node whose learning trace can be opened",
  "trace.invalidEvEvidence": "The EV evidence response is invalid.",
  "trace.invalidEvNumber": "The EV evidence contains an invalid number.",
  "trace.missingEvIdentifier":
    "The EV evidence is missing a required identifier.",
  "trace.invalidErwApplied": "The ERW application status is invalid.",
  "trace.invalidErwAggressor": "The ERW aggressor seat is invalid.",
  "trace.invalidErwEvidenceList": "The ERW evidence list is invalid.",
  "trace.activeSeatsUnrecorded": "Active seats were not recorded.",
  "trace.unsupportedErwVersion": "The ERW formula version is not supported.",
  "trace.invalidOpponentPooling": "The opponent ERW aggregation is invalid.",
  "trace.invalidOpponentPoolingInput": "The opponent ERW input is invalid.",
  "trace.invalidEvEvidenceList": "The EV evidence list is invalid.",
  "trace.invalidOpponentHandList": "The opponent hand list is invalid.",
  "trace.invalidSidePotEvidence": "The side-pot evidence is invalid.",
  "publicSolve.title": "Public Solve",
  "publicSolve.missingToken": "Missing public solve token.",
  "publicSolve.notFoundMessage": "Public solve not found.",
  "publicSolve.loadFailed": "Failed to load public solve.",
  "publicSolve.loading": "Loading public solve...",
  "publicSolve.notFound": "Solve Not Found",
  "publicSolve.unableToLoad": "Unable To Load Solve",
  "publicSolve.board": "Board",
  "publicSolve.exploitability": "Exploitability",
  "publicSolve.iterations": "Iterations",
  "publicSolve.views": "Views",
  "publicSolve.source": "Source",
  "publicSolve.created": "Created {date}",
  "publicSolve.config": "Config",
  "publicSolve.result": "Result",
  "publicSolve.noResult": "No result data",
  "documents.backLabel": "Go back to previous page",
  "documents.back": "← Back",
  "documents.title": "Documents",
  "documents.locktreeDocuments": "Locktree Documents",
  "documents.description":
    "Locktree is a SaaS solver that calculates poker GTO strategy in real time. Below are code-level walkthroughs, architecture decision records (ADRs), and precompute artifacts for engineers contributing to the solver.",
  "documents.codeWalkthrough": "Code Walkthrough",
  "documents.adr": "Architecture Decision Records",
  "documents.precomputeArtifacts": "Precompute Artifacts",
  "documents.algorithmFlow": "Algorithm Flow",
  "documents.architectureAdr": "Architecture ADR",
  "documents.preflopWalkthroughTitle": "Preflop CFR — Walkthrough",
  "documents.preflopWalkthroughDescription":
    "Follow the preflop solver from four perspectives: execution flow from the HTTP request through game-tree traversal; the step-by-step evolution of InfoSet data (regret_sum_, strategy_sum_, prunable_mask_); Terminal Utility calculations for utility, blockers, and card removal at leaf nodes; and the GameNode model decomposed into its five responsibilities.",
  "documents.postflopWalkthroughTitle": "Postflop CFR Solve — Code Walkthrough",
  "documents.postflopWalkthroughDescription":
    "Trace how the postflop solver completes one cycle through streets, subgames, and ranges, showing the core stages from tree construction through convergence checks.",
  "documents.regretAdrTitle": "Postflop MCCFR — Regret Synchronization ADR",
  "documents.regretAdrDescription":
    "An ADR documenting how postflop MCCFR regret synchronization was chosen, including the adopted 1024-stripe StripedNodeMutex structure and its code locations.",
  "documents.openNewTab": "New tab",
  "cardMnemonic.title": "Card Syllable Memorization",
  "cardMnemonic.nextQuestion": "Next question (Space)",
  "cardMnemonic.showAnswer": "Show answer (Space)",
  "cardMnemonic.quizHelp":
    "Think of the two syllables represented by the cards, then check the answer.",
  "cardMnemonic.firstCard": "First card",
  "cardMnemonic.secondCard": "Second card",
  "cardMnemonic.collapseCombinations": "Hide all combinations",
  "cardMnemonic.showCombinations": "Show all combinations ({count})",
  "cardMnemonic.mnemonicWord": "Mnemonic word",
  "cardMnemonic.syllable": "Syllable",
  "cardMnemonic.collapseTable": "Hide conversion table",
  "cardMnemonic.expandTable": "Show conversion table",
  "cardMnemonic.rankInitial": "Rank → initial consonant",
  "cardMnemonic.suitMedial": "Suit → medial vowel",
  "cardMnemonic.noFinalConsonant":
    "Do not use a final consonant. Syllable = initial consonant + medial vowel.",
  "errorBoundary.chunkTitle": "Chunk load error",
  "errorBoundary.chunkMessage":
    "A newer app bundle may be available. Reload the page to fetch the latest version.",
  "errorBoundary.networkTitle": "Network error",
  "errorBoundary.networkMessage":
    "The React app could not finish loading because a network request failed.",
  "errorBoundary.renderTitle": "Render error",
  "errorBoundary.renderMessage":
    "The React app hit an unexpected render error.",
  "errorBoundary.unableToLoad": "Unable to load app",
  "errorBoundary.reload": "Reload",
  "game.tableTitle": "9-max GTO Bot Table",
  "game.setupHelp": "Configure your table and start playing",
  "game.stackSize": "Stack Size: {stack} BB",
  "game.botStyles": "Bot Styles (8 players)",
  "game.seat": "Seat {seat}",
  "game.start": "Start Game",
  "game.presetAllGto": "All GTO",
  "game.presetMixed": "Mixed Table",
  "game.presetShark": "Shark Tank",
  "game.presetWild": "Wild West",
  "game.botGto": "GTO Balanced",
  "game.botLag": "Loose-Aggressive (LAG)",
  "game.botTag": "Tight-Aggressive (TAG)",
  "game.botLp": "Loose-Passive (LP)",
  "game.botTp": "Tight-Passive (TP)",
  "game.botManiac": "Maniac",
  "game.botRock": "Rock",
  "game.localPlay": "Local Play",
  "game.localRoom": "Local",
  "game.you": "You",
  "game.bot": "Bot {seat}",
  "game.preflop": "Pre-flop",
  "game.flop": "Flop",
  "game.turn": "Turn",
  "game.river": "River",
  "game.fold": "FOLD",
  "game.check": "CHECK",
  "game.callAmount": "CALL {amount}",
  "game.betAmount": "BET {amount}",
  "game.raiseAmount": "RAISE {amount}",
  "game.allIn": "ALL IN",
  "game.handNumber": "Hand #{number}",
  "game.sidePot": "Side pot: {amount}",
  "game.staleBotResult": "Ignored a bot result from a previous game.",
  "game.noActiveGame": "There is no game in progress.",
  "convergence.targetsNotMet": "⚠️ This result did not meet the targets",
  "convergence.unavailable": "⚠️ Convergence cannot be assessed",
  "convergence.metrics":
    "· exploitability {exploitability} / target {target} · max gap {gap} / target {gapTarget}",
  "auth.genericError": "Unable to sign in. Please try again.",
  "online.roomCode": "Room code",
  "online.copyRoomCode": "Click to copy",
  "online.copied": "Copied!",
  "online.shareCode": "Share this code with your friends",
  "online.gameType": "Game type",
  "online.participants": "Participants ({count}/9)",
  "online.me": "(Me)",
  "online.host": "Host",
  "online.startGame": "Start game",
  "online.needPlayers": "You can start when at least 2 players have joined",
  "online.waitingForHost": "Waiting for the host to start the game…",
  "online.leaveRoom": "Leave room",
  "online.title": "Hold'em with Friends",
  "online.landingHelp": "Create a room or join with a code to play together",
  "online.nickname": "Nickname",
  "online.nicknamePlaceholder": "Name shown at the table",
  "online.normalGame": "Normal game",
  "online.normalGameHelp": "Fixed blinds · Play until the chips run out",
  "online.customGameHelp": "Enter the stack, level length, and blinds yourself",
  "online.createRoom": "Create new room",
  "online.or": "or",
  "online.joinCodePlaceholder": "Room code",
  "online.join": "Join",
  "online.connectingServer": "Connecting to server…",
  "online.room": "Room {roomCode}",
  "online.eliminated":
    "Eliminated in {rank} place · Watching the rest of the game",
  "online.unknownPlayer": "Unknown player",
  "online.jointWinner": "Joint winner",
  "online.winner": "Winner",
  "online.winnerAnnouncement": "{names} ({label})",
  "online.gameOver": "Game over",
  "online.finalStandings": "Final standings",
  "online.resultUnavailable": "Could not load the results.",
  "online.backToLobby": "Back to lobby",
  "online.onlineHoldem": "Online Hold'em",
  "online.reconnectingTitle": "Restoring connection",
  "online.reconnecting": "Reconnecting to the server. Please wait.",
  "online.connecting": "Connecting to the server...",
  "online.disconnected":
    "The server connection was lost. Reconnecting automatically.",
  "online.supersededTitle": "This room was opened in another tab",
  "online.supersededHelp":
    "The game is still running in the other tab. To continue in this tab, press the button below.",
  "online.continueHere": "Continue in this tab",
  "online.gameStatus": "Game status",
  "online.blinds": "Blinds",
  "online.ante": "Ante",
  "online.next": "Next",
  "online.startingStack": "Starting stack",
  "online.levelMinutes": "Level length (minutes)",
  "online.endMethod": "End method",
  "online.lastSurvivor": "Until one player remains",
  "online.lastSurvivorHelp": "Rank by elimination order",
  "online.afterFinalLevel": "End after the final level",
  "online.afterFinalLevelHelp": "Rank by remaining chips",
  "online.levelBlinds": "Blinds by level (leave ante empty for none)",
  "online.smallBlind": "Small blind",
  "online.bigBlind": "Big blind",
  "online.level": "Lv {level}",
  "online.levelField": "Level {level} {field}",
  "online.deleteLevel": "Delete level {level}",
  "online.delete": "Delete",
  "online.addLevel": "Add level",
  "online.tournament100bb": "Tournament 100BB",
  "online.timeAttack": "Time attack",
  "online.custom": "Custom",
  "online.beforeStart": "Not started",
  "online.ended": "Ended",
  "online.finalLevel": "Final level",
  "online.nextHand": "From the next hand",
  "online.finalHand": "Through this hand",
  "online.tableTitle":
    "Room {roomCode} · {levelText} · {blindsText} · {countdownText}",
  "online.levelProgress": "Lv {current}/{total}",
  "online.anteValue": "Ante {value}",
  "online.scheduleSummary":
    "Start at {startingBigBlinds}BB · {levelMinutes}-minute levels · Blinds from {smallBlind}/{bigBlind}",
  "online.scheduleSummaryFinal":
    "Start at {startingBigBlinds}BB · {levelMinutes}-minute levels · Blinds from {smallBlind}/{bigBlind} · End after {levelCount} levels, rank by remaining chips",
  "online.nextBlindsWithAnte": "{blinds} · Ante {ante}",
  "online.tournament": "Tournament",
  "online.status": "Status",
  "online.untilNextLevel": "Next level in",
  "online.remainingTime": "Time remaining",
  "online.untilEnd": "Ends in",
  "online.errorReconnecting": "Reconnecting. Please try again shortly.",
  "online.errorDisconnected":
    "Not connected to the server. Please try again shortly.",
  "online.errorTakeoverDelayed":
    "The response is delayed while reclaiming the session. Please try again.",
  "online.errorTakeoverFailed": "Could not reclaim the session.",
  "online.errorReconnectFailed": "Could not reconnect.",
  "online.errorTakeoverDisconnected":
    "The connection was lost and the session could not be reclaimed. Please try again.",
  "online.errorLeaveBeforeCreate":
    "Leave the current room before creating another one.",
  "online.errorCreateFailed": "Could not create the room.",
  "online.errorLeaveBeforeJoin":
    "Leave the current room before joining another one.",
  "online.errorInvalidJoinResponse": "The room join response is invalid.",
  "online.errorJoinFailed": "Could not join the room.",
  "online.errorStartFailed": "Could not start the game.",
  "online.errorActionFailed": "Action failed",
  "online.errorNextHandFailed": "Next hand failed",
  "online.errorReturnLobbyFailed": "Could not return to the lobby.",
  "online.errorLeaveFailed": "Could not leave the room.",
  "online.invalidSchedule": "The tournament schedule is invalid.",
  "online.invalidStartingStack":
    "Starting stack must be an integer from 1 to {maximum}.",
  "online.invalidLevelMinutes":
    "Level length must be an integer from {minimum} to {maximum} minutes.",
  "online.invalidEndMethod": "The end method is invalid.",
  "online.invalidLevelCount": "Enter between 1 and {maximum} levels.",
  "online.invalidLevelFormat": "Level {level} has an invalid format.",
  "online.invalidBigBlind":
    "Level {level} big blind must be an integer of at least 2.",
  "online.invalidSmallBlind":
    "Level {level} small blind must be an integer of at least 1 and less than the big blind.",
  "online.invalidAnte":
    "Level {level} ante must be an integer from 0 through the big blind.",
  "online.invalidLevelOrder":
    "Level {level} must not decrease from the previous level and must increase at least one value.",
  "online.invalidStartingStackBlind":
    "Starting stack must be at least {multiple} times the first level big blind.",
  "pokerth.raiseSlider": "Raise amount slider",
  "pokerth.raiseAmount": "Raise amount",
  "pokerth.allInShortcut": "All-In (A)",
  "pokerth.foldShortcut": "Fold (F)",
  "pokerth.checkShortcut": "Check (C)",
  "pokerth.callShortcut": "Call (C)",
  "pokerth.raiseShortcut": "Raise (R)",
  "pokerth.actionPreview": "Action preview",
  "pokerth.total": "Total:",
  "pokerth.bets": "Bets:",
  "pokerth.room": "Room:",
  "pokerth.quit": "Quit",
  "pokerth.handResult": "Hand result",
  "pokerth.youWon": "You won",
  "pokerth.handWinner": "Hand winner",
  "pokerth.hand": "Hand",
  "pokerth.totalPot": "Total pot",
  "pokerth.players": "Players",
  "pokerth.blinds": "Blinds",
  "pokerth.communityCards": "Community cards",
  "pokerth.results": "Results",
  "pokerth.nextHand": "Next Hand",
  "pokerth.leaveTable": "Leave table",
  "pokerth.winner": "WINNER",
  "handValidation.outOfTurn": "The action is out of turn.",
  "handValidation.minRaise": "The raise amount is below the minimum raise.",
  "handValidation.minRaiseHelp":
    "Minimum raise to = max(previous raise size, big blind) + current bet.",
  "handValidation.stackUnderflow":
    "The bet amount exceeds the available stack.",
  "handValidation.noReopen":
    "The previous short all-in does not reopen betting.",
  "handValidation.noReopenHelp":
    "A player who has already acted may only call in this situation.",
  "handValidation.raiseCovered":
    "The stack is no greater than the call amount, so raising is unavailable.",
  "handValidation.raiseCoveredHelp": "Treat this as a call.",
  "handValidation.noEligibleOpponent":
    "There is no eligible opponent to face a raise (everyone else folded or is all-in).",
  "handValidation.noMoreRaise": "No further raises are allowed in this round.",
  "handValidation.illegalCheck": "The player checked while facing a bet.",
  "handValidation.illegalCheckHelp": "The player must call or fold.",
  "handValidation.streetPremature":
    "The hand advanced to the next street before the betting round ended.",
  "handValidation.unknownAction": "The action could not be interpreted.",
  "handValidation.unknownPlayer": "Unknown player",
  "handValidation.action": "action",
  "handValidation.preflop": "Preflop",
  "handValidation.flop": "Flop",
  "handValidation.turn": "Turn",
  "handValidation.river": "River",
  "handValidation.missingResponse":
    "On {street}, {player} has no response after {aggressor} {action}.",
  "handValidation.missingAction": "On {street}, {player} has no action.",
  "handValidation.missingResponseHelp":
    "Check the original hand history and add this player's call, fold, or raise response.",
  "handValidation.missingActionHelp":
    "Check the original hand history and add this player's check or bet action.",
  "handValidation.actionRequired": "{player} must act",
  "handValidation.missingBlinds":
    "Preflop has no blind-posting actions (Post SB, Post BB), so action-order validation was skipped.",
  "handValidation.missingBlindsHelp":
    "Add Post SB and Post BB to validate the action order.",
  "handValidation.withDetail": "{message} ({detail})",
  "handValidation.potTotalMismatch":
    "The OHH pot total {actual} differs from the actual contribution {expected}.",
  "handValidation.potTotalHelp":
    "Check the blind/bet action amounts or pots[].amount.",
  "handValidation.collectedMismatch":
    "The collected total {actual} differs from the pot total {expected}.",
  "handValidation.collectedHelp":
    "Check player_wins[].win_amount and pots[].amount.",
  "handValidation.potCountMismatch":
    "The OHH pot count {actual} differs from the replay pot count {expected}.",
  "handValidation.potCountHelp":
    "Check the side-pot boundaries and the number of pots[] entries.",
  "handValidation.potAmountMismatch":
    "OHH pot #{number} amount {actual} differs from replay pot amount {expected}.",
  "handValidation.potAmountHelp":
    "Check side-pot amounts at each player-contribution boundary.",
  "handValidation.ineligiblePlayer":
    "player_id {playerId} is not eligible to collect pot #{number}.",
  "handValidation.ineligiblePlayerHelp":
    "The player cannot collect a side pot above their all-in contribution.",
  "handValidation.positionNoActions":
    'Player position "{position}" has no preflop actions (excluding blinds/antes).',
  "handValidation.parseFailed": "JSON parse failed: {message}",
  "handValidation.rootObject": "The OHH root must be a JSON object.",
  "handValidation.ohhObject": "ohh must be a JSON object.",
  "handValidation.missingGameType": "game_type is missing or empty.",
  "handValidation.unsupportedGame":
    "Unsupported game (game_type={gameType}, bet_type={betType}). Only NL Hold'em is validated.",
  "handValidation.playersArray": "players must be an array.",
  "handValidation.tooFewPlayers": "There are fewer than two players.",
  "handValidation.missingRounds": "rounds is missing or is not an array.",
  "handValidation.invalidSmallBlind":
    "small_blind_amount is missing or no greater than 0.",
  "handValidation.invalidBigBlind": "big_blind_amount is missing or 0.",
  "handValidation.playerObject": "player must be an object.",
  "handValidation.playerFieldMissing": "player.{field} is missing.",
  "handValidation.negativeStack":
    "player {playerId} has a negative starting_stack.",
  "handValidation.duplicateCard": "Duplicate card found: {card}",
  "handValidation.roundObject": "round must be an object.",
  "handValidation.roundStreetMissing": "round.street is missing.",
  "handValidation.roundActionsMissing": "round.actions is missing.",
  "handValidation.boardCardCount":
    "The {street} board does not have {count} cards.",
  "handValidation.badBoardCard": "Invalid board card format: {card}",
  "handValidation.actionObject": "action must be an object.",
  "handValidation.actionNumberMissing": "action_number is missing.",
  "handValidation.actionStringMissing": "The action string is missing.",
  "handValidation.badHoleCard": "Invalid hole card format: {card}",
  "handValidation.actionPlayerMissing":
    "action {actionNumber}: player_id is missing.",
  "handValidation.unknownPlayerId":
    "action {actionNumber}: unknown player_id {playerId}",
  "handValidation.unknownActionMapping": "Unmapped action: {action}",
  "results.hand": "Hand",
  "results.weightBar": "Weight (Bar)",
  "results.combos": "Combos",
  "results.combosBar": "Combos (Bar)",
  "results.eq": "EQ",
  "results.ev": "EV",
  "results.turn": "Turn",
  "results.river": "River",
  "results.reportsUnavailable": "{street} reports not available",
  "results.noResults": "No results",
  "game.chipUnit": "chips",
  "preflopTree.raiseAmount": "Raise {amount}",
  "preflopSolution.loadingCached": "Loading cached strategy…",
  "preflopSolution.loadingPrecomputed": "Loading precomputed strategy…",
  "preflopSolution.initializingTree": "Initializing game tree…",
  "preflopSolution.exportingResults": "Exporting results…",
  "preflopSolution.solving": "Solving ({current}/{target}{exploitability})…",
  "preflopSolution.timeout": "Solve timed out after 15 minutes.",
  "preflopSolution.missingStrategyNodes":
    "Solve completed without strategy nodes.",
  "resultViewer.workerInitFailed": "Failed to initialize solver worker.",
  "resultViewer.cachedTreeUnavailable": "Cached tree not found or unavailable.",
  "resultViewer.cachedTreeLoadFailed": "Failed to load cached tree.",
  "dbItemPicker.parseError": "Parse error (invalid JSON)",
  "dbItemPicker.dataTypeMismatch": "Data type mismatch",
  "dbItemPicker.versionMismatch": "Version mismatch",
  "dbItemPicker.invalidData": "Invalid data",
  "trace.unexpectedErrorResponse": "Unexpected error response.",
  "trace.invalidResponse": "Invalid preflop trace response: {detail}",
  "treeConfig.handlerNotInitialized": "Handler not initialized",
  "treeConfig.rebuiltTreeUnavailable": "Failed to get rebuilt tree",
  "aiSetup.extractedField": "extracted field",
  "aiSetup.imageParseConfidence":
    "Image parse confidence {confidence}% for {label}",
  "aiSetup.reviewScreenshotReason":
    "Review against the original screenshot: {reason}",
  "aiSetup.reviewScreenshot":
    "Review this extracted field against the original screenshot.",
  "pokerth.pot": "Pot",
  "handHistory.unknownError": "Unknown error",
  "aiSetup.blindsAntes": "Blinds / Antes",
  "aiSetup.preflop": "Preflop",
  "aiSetup.flop": "Flop",
  "aiSetup.turn": "Turn",
  "aiSetup.river": "River",
  "aiSetup.unknown": "Unknown",
  "preflopSolution.invalidResponse": "Invalid preflop solve response: {detail}",
  "apiError.network":
    "Unable to connect to the server. Please check your internet connection and try again.",
  "apiError.server": "The server encountered an error. Please try again later.",
  "apiError.invalidData":
    "The provided data is invalid. Please check your input.",
  "apiError.parse": "Failed to process the server response. Please try again.",
  "apiError.unexpected": "An unexpected error occurred. Please try again.",
  "apiError.sessionExpired": "Your session has expired. Please log in again.",
  "apiError.permissionDenied":
    "You do not have permission to perform this action.",
  "apiError.notFound": "The requested resource was not found.",
  "apiError.tooManyRequests":
    "Too many requests. Please wait a moment and try again.",
  "apiError.requestInvalid":
    "The request could not be processed. Please check your input and try again.",
  "httpClient.network":
    "Unable to connect to the server. Please check your internet connection.",
  "httpClient.cancelled": "Request was cancelled",
  "jsonResponse.empty":
    "{context} returned an empty response (HTTP {status}). The server may have timed out or disconnected. Please retry.",
  "jsonResponse.malformed":
    "{context} returned a malformed JSON response (HTTP {status}). Please retry.",
  "apiContext.preflopHandAnalysis": "Preflop hand analysis",
  "apiContext.preflopSolve": "Preflop solve",
  "apiContext.preflopTraceProfile": "Preflop trace profile",
  "apiContext.preflopTraceSubtree": "Preflop trace subtree",
  "apiContext.preflopTerminalEvidence": "Preflop terminal evidence",
  "apiContext.reachingRangesJobStart": "Reaching ranges job start",
  "apiContext.reachingRangesRequest": "Reaching ranges request",
  "apiContext.reachingRangesPoll": "Reaching ranges poll",
  "apiContext.aiSetupRun": "AiSetup run",
  "apiContext.aiSetupPoll": "AiSetup poll",
  "apiContext.fullSolverHandoff": "FullSolverHandoff run",
  "auth.registrationFailed": "Registration failed",
  "auth.loginFailed": "Login failed",
  "auth.resendVerificationFailed": "Failed to resend verification email",
  "auth.networkError": "Network error. Please try again.",
  "auth.oauthEmailAlreadyRegistered":
    "An account with this email already exists. Please use the original sign-in method.",
  "auth.logoutFailed": "Could not log out. Please try again later.",
  "db.loginToSave": "Please log in to save ranges and configurations.",
  "db.loginToModify": "Please log in to modify ranges and configurations.",
  "db.loginToDelete": "Please log in to delete ranges and configurations.",
  "lockTemplate.defaultStrategy": "Strategy lock",
  "lockTemplate.defaultNodeRemoval": "Node removal lock",
  "lockTemplate.defaultRange": "Range lock",
  "solverStage.aiSetup": "AI Setup",
  "solverStage.preflopActionTree": "Preflop Action Tree",
  "solverStage.oopRange": "OOP Range",
  "solverStage.ipRange": "IP Range",
  "solverStage.board": "Board",
  "solverStage.treeConfiguration": "Tree Configuration",
  "solverStage.runSolver": "Run Solver",
  "solverStage.result": "Result",
  "aiSetupView.importDescription":
    "Turn a table screenshot or a hand history into a solver-ready spot.",
  "aiSetupView.preflopTreeDescription":
    "Preflop strategy for the imported hand, position by position.",
  "aiSetupView.boardDescription":
    "Choose the community cards for the postflop solve.",
  "aiSetupView.treeDescription":
    "Bet sizes, pot and stacks for the solver tree.",
  "aiSetupView.runDescription": "Start the solve and watch it converge.",
  "aiSetupView.resultDescription": "Strategies and EVs for the solved spot.",
  "preflopOverview.premiumPairs": "Premium Pairs (AA-JJ)",
  "preflopOverview.mediumPairs": "Medium Pairs (TT-77)",
  "preflopOverview.smallPairs": "Small Pairs (66-22)",
  "preflopOverview.bigBroadway": "Big Broadway (AK-AJ, KQ)",
  "preflopOverview.mediumBroadway": "Medium Broadway (AT-KT, QJ-JT)",
  "preflopOverview.suitedConnectors": "Suited Connectors",
  "preflopOverview.suitedAces": "Suited Aces",
  "preflopOverview.otherCategory": "Other",
  "rangeParser.invalidWeightFormat": "Invalid weight format: {value}",
  "rangeParser.invalidWeightValue": "Invalid weight value: {value}",
  "rangeParser.parseFailed": "Failed to parse range: {value}",
  "rangeParser.emptyExpression": "(empty string)",
  "rangeParser.duplicateCard": "Cannot have same card twice",
  "rangeParser.invalidSuitedness": "Invalid suitedness type",
  "rangeParser.invalidRankCharacter": "Invalid rank character: {value}",
  "rangeParser.invalidRankIndex": "Invalid rank index: {value}",
  "rangeParser.invalidSuitCharacter": "Invalid suit character: {value}",
  "rangeParser.invalidComboIndex": "Invalid combo index: {value}",
  "rangeParser.invalidCardIndex": "Invalid card index: {value}",
  "rangeParser.invalidCombo": "Invalid combo: {value}",
  "rangeParser.invalidSuitednessSuffix": "Invalid suitedness suffix: {value}",
  "rangeParser.invalidComboFormat": "Invalid combo format: {value}",
  "rangeParser.invalidRangeExpression": "Invalid range expression: {value}",
  "rangeParser.mixedPairRange":
    "Invalid range expression: {value} (cannot mix pairs and non-pairs)",
  "rangeParser.inconsistentSuitedness":
    "Inconsistent suitedness in range: {value} (cannot mix suited/offsuit/all)",
  "rangeParser.higherRankMismatch":
    "Invalid range expression: {value} (non-pair ranges must have same higher rank, e.g., AK-AQ)",
  "rangeParser.invalidRowColumn": "Invalid row/col: {row}, {column}",
  "treeManager.noTree": "No tree loaded",
  "treeManager.notEditing": "Not in edit mode",
  "treeManager.emptyLine": "Empty line",
  "treeManager.unexpectedTerminal": "Unexpected terminal node",
  "treeManager.chanceWithoutChildren": "Chance node has no children",
  "utility.tooManyBetSizes": "Too many bet sizes",
  "utility.emptyString": "Found empty string",
  "utility.invalidLine": "Invalid line string",
  "utility.allIn": "All-in",
  "utility.multiplicativeNotAllowed":
    "Multiplicative size is not allowed: {value}",
  "utility.invalidMultiplicative": "Invalid multiplicative size: {value}",
  "utility.multiplierTooSmall": "Multiplier must be greater than 1: {value}",
  "utility.invalidAdditive": "Invalid additive size: {value}",
  "utility.additionMustBeInteger": "Addition size must be an integer: {value}",
  "utility.additionTooLarge": "Addition size too large: {value}",
  "utility.raiseCapNotAllowed":
    "Addition with raise cap is not allowed: {value}",
  "utility.raiseCapMustBePositiveInteger":
    "Raise cap must be a positive integer: {value}",
  "utility.raiseCapTooLarge": "Raise cap too large: {value}",
  "utility.invalidGeometric": "Invalid geometric size: {value}",
  "utility.geometricMustBePositiveInteger":
    "Geometric size must be a positive integer: {value}",
  "utility.geometricTooLarge": "Geometric size too large: {value}",
  "utility.invalidBetSize": "Invalid bet size: {value}",
  "jsonFormat.unrepresentable": "Value cannot be represented as JSON",
  "validation.nodePathNegative":
    "Invalid node path: action indices must be non-negative. Found negative value in {value}",
  "validation.actionIndicesNegative":
    "Invalid action indices: all action indices must be non-negative.",
  "validation.nodePathFormat":
    "Invalid node path format. Expected comma-separated numbers (e.g., '0,1,2'), but found non-numeric values. Please check your input.",
  "validation.probabilitySum":
    "Probabilities for {context} must sum to 1.0 (got {sum}). Current values: [{values}].",
  "validation.probabilityFormat":
    'Invalid probabilities for {context}: "{value}". Expected comma-separated decimal numbers (e.g., "0.0,1.0,0.0").',
  "validation.probabilityRange":
    "Invalid probability value {value} for {context}. All probabilities must be between 0.0 and 1.0.",
  "validation.actionsRequired":
    "No actions specified for removal. Please enter at least one action index (e.g., '0' for fold, '2' for raise).",
  "validation.actionIndicesFormat":
    "Invalid action indices format. Expected comma-separated numbers (e.g., '0,2'), but found non-numeric values.",
  "validation.handIndexRange":
    "Hand index must be between 0 and 1325, got: {value}",
  "validation.handNotation": 'Invalid hand notation "{value}": {error}',
  "resultViewer.copyPlaceholder": "Hello World",
  "worker.buildTreeFailed": "Failed to build tree",
  "worker.missingTreeData": "No tree data in build-tree response",
  "worker.stoppedByUser": "Solver stopped by user",
  "worker.solverError": "Solver encountered an error",
  "worker.cleanupResultUnavailable":
    "Solve result is unavailable after server cleanup",
  "worker.failedStatus": "Solver failed with error status",
  "worker.resultsFailed": "Failed to get results",
  "worker.incrementalJobIdMissing": "Job ID not set for incremental results",
  "worker.currentResultsFailed": "Failed to get current results",
  "worker.jobIdMissing": "Job ID not set",
  "worker.gameNotLoaded": "Game not loaded",
  "worker.actionsFailed": "Failed to get actions after",
  "worker.gameStateMissing":
    "Game state not cached - applyHistory() may not have been called",
  "worker.treeNotBuilt": "The tree is not built yet. Build the tree first.",
  "worker.gameTreeUnavailable": "Game tree not available",
  "worker.startFailed": "Failed to start solver",
  "worker.finalizeTimeout": "Solver finalize timeout - exceeded 10 minutes",
  "worker.invalidTreePath": "Invalid tree path: [{path}]",
  "aiSetupClient.pollTimeout":
    "AiSetup polling timed out after {seconds}s. The server may still be running.",
  "aiSetupClient.nonObjectPayload":
    "{context} returned a non-object session payload.",
  "aiSetupClient.missingSessionId": "{context} returned no session_id.",
  "aiSetupClient.unknownStage":
    "{context} returned an unknown session stage: {stage}",
  "aiSetupClient.unknownStatus":
    "{context} returned an unknown session status: {status}",
  "aiSetupClient.networkError": "Network error",
  "aiSetupClient.pollingFailed": "AiSetup polling failed: {error}",
  "aiSetupClient.failed": "AiSetup failed ({code}){detail}",
  "gtoScore.calculateFailed": "Failed to calculate GTO score",
  "gtoScore.networkError": "Network error occurred",
  "gtoScore.httpError": "HTTP error: {status} {statusText}",
  "gtoScore.fold": "Fold",
  "gtoScore.check": "Check",
  "gtoScore.call": "Call",
  "gtoScore.bet": "Bet ${amount}",
  "gtoScore.raise": "Raise ${amount}",
  "gtoScore.allIn": "All-in ${amount}",
  "gtoScore.postsSb": "Posts SB",
  "gtoScore.postsBb": "Posts BB",
  "gtoScore.postsAnte": "Posts Ante",
  "gtoScore.unknown": "Unknown",
  "handHistory.analysisFailed": "Failed to analyze preflop hand",
  "preflopSolve.htmlError":
    "Server error ({status}): The server returned an HTML error page instead of JSON. This usually means the server crashed or timed out.",
  "preflopSolve.unexpectedResponse":
    "Unexpected response from server ({status}): expected JSON but received: {body}",
  "publicSolve.invalidToken": "Invalid public solve token",
  "reachingRanges.unknownError": "Unknown error",
  "reachingRanges.apiError": "API error ({status}): {error}",
  "reachingRanges.missingJobId": "No job_id returned from reaching-ranges API",
  "reachingRanges.networkError": "Network error",
  "reachingRanges.pollingFailed": "Polling failed: {error}",
  "reachingRanges.pollError": "Poll error ({status}){detail}",
  "reachingRanges.solveFailed": "CFR solve failed: {error}",
  "reachingRanges.noErrorDetails": "Server returned no error details",
  "reachingRanges.unexpectedStatus": 'Unexpected job status: "{status}"',
  "scenario.serverError": "Server returned error",
  "scenario.missingHandHistory": "Server response missing handHistory field",
  "scenario.parserUnavailable": "Cannot connect to parser API server at {url}",
  "scenario.parserPortHelp": "Make sure the server is running on port 8080",
  "scenario.apiUnavailable":
    "Cannot connect to API server. Please check if the server is running.",
  "scenario.backendHelp": "Make sure the backend server is running",
  "scenario.networkHelp": "Check network connection",
  "scenario.imageParseFailed": "Failed to parse image: {error}",
  "scenario.textParseFailed": "Failed to parse text: {error}",
  "solveHistory.invalidEntryId": "Invalid history entry ID",
  "bracketText.unexpectedFailure": "Unexpected conversion failure: {error}",
  "bracketText.awayAsFold": "AWAY was represented as Fold",
  "bracketText.duplicateSection": "Duplicate {marker} section.",
  "bracketText.sectionOutOfOrder": "{marker} section is out of order.",
  "bracketText.unknownSection": "Unknown section marker.",
  "bracketText.missingSection": "{marker} section is missing.",
  "bracketText.unknownHeader": "Unknown header line.",
  "bracketText.missingHandNumber": "Hand number is missing.",
  "bracketText.badBlindsHeader": "Blinds header is missing or malformed.",
  "bracketText.badStackLine": "Malformed stack line.",
  "bracketText.unknownPosition": "Unknown position: {position}.",
  "bracketText.duplicatePlayer": "Duplicate player name: {name}.",
  "bracketText.duplicatePosition": "Duplicate position: {position}.",
  "bracketText.minimumPlayers": "At least two players are required.",
  "bracketText.headsUpUnsupported":
    "Heads-up (2-player) hands are not supported yet.",
  "bracketText.positionRequired": "{position} position is required.",
  "bracketText.singleDealtLine": "Exactly one dealt-cards line is required.",
  "bracketText.badDealtLine": "Malformed dealt-cards line.",
  "bracketText.preflopPotRequired": "Preflop Pot line is required.",
  "bracketText.boardCardsNotAllowed":
    "This section must not contain board cards.",
  "bracketText.multiplePotLines":
    "Multiple Pot lines in one section are unsupported.",
  "bracketText.allInUnsupported": "All-in tokens are unsupported.",
  "bracketText.badActionLine": "Malformed action line.",
  "bracketText.unknownAction": "Unknown action token: {action}.",
  "bracketText.sidePotsUnsupported": "Side pots are unsupported.",
  "bracketText.unknownWinnerPosition": "Unknown winner position: {position}.",
  "bracketText.unknownResultLine": "Unknown result line.",
  "bracketText.winnerRequired": "Winner line is required.",
  "bracketText.multipleWinnersUnsupported": "Multiple winners are unsupported.",
  "bracketText.resultPotRequired": "Result Pot line is required.",
  "bracketText.playerMissing":
    "Player {player} is absent from PRE-HAND STACKS.",
  "bracketText.playerPositionMismatch":
    "Position for {player} does not match PRE-HAND STACKS.",
  "bracketText.winnerMissing":
    "Winner {player} is absent from PRE-HAND STACKS.",
  "bracketText.winnerPositionMismatch":
    "Winner position for {player} does not match PRE-HAND STACKS.",
  "bracketText.preflopOrderMismatch":
    "Preflop first-appearance order contradicts seat order.",
  "bracketText.expectedBracketedCards":
    "Expected {count} individually bracketed cards.",
  "bracketText.invalidCard": "Invalid card: {card}.",
  "bracketText.incompleteStructure": "Required hand structure is incomplete.",
  "bracketText.stackPrecision":
    "Stack for {player} exceeds supported precision.",
  "bracketText.preflopPotPrecision": "Preflop pot exceeds supported precision.",
  "bracketText.anteModelMismatch":
    "Declared preflop pot does not match any supported ante payer model.",
  "bracketText.antePayersAmbiguous": "Ante payer set is ambiguous.",
  "bracketText.heroMissing": "Hero is absent from PRE-HAND STACKS.",
  "bracketText.resultPotMismatch":
    "Result pot does not equal converted contributions.",
  "bracketText.btnRequired":
    "BTN position is required to determine dealer seat.",
  "bracketText.winnerAbsent": "Winner is absent from PRE-HAND STACKS.",
  "bracketText.forcedBetExceedsStack": "Forced bets exceed {player}'s stack.",
  "bracketText.actionExceedsStack":
    "{player}'s action exceeds the starting stack.",
  "bracketText.actionAmountMissing": "{action} amount is missing.",
  "bracketText.actionTargetTooSmall":
    "{action} target must exceed the player's street contribution.",
  "bracketText.declaredPotMismatch":
    "Declared Pot does not equal converted contributions.",
  "bracketText.badMoney": "A money value is malformed.",
  "bracketText.moneyPrecision": "Money precision exceeds the supported range.",
  "bracketText.valuePrecision": "{label} exceeds supported precision.",
  "bracketText.smallBlind": "small blind",
  "bracketText.bigBlind": "big blind",
  "bracketText.ante": "ante",
  "pokerStars.exportFailed": "Cannot export as PokerStars text: {detail}",
  "pokerStars.duplicateCards": "The same card appears twice: {cards}",
  "pokerStars.unreadableCards": "There are unreadable cards: {cards}",
  "pokerStars.invalidHeroCardCount":
    "The hero needs 2 hole cards but has {actual}",
  "pokerStars.buttonBlindMismatch":
    "Button seat {buttonSeat} should be seat {expectedButtonSeat} for small blind seat {smallBlindSeat}",
  "pokerStars.unsupportedBetLimit": "Unsupported bet limit: {betType}",
  "pokerStars.unsupportedCurrency":
    "Unsupported currency: {currency} (supported: USD, EUR, GBP, CNY)",
  "pokerStars.unsupportedGameType": "Unsupported game type: {gameType}",
  "pokerStars.unsupportedAction": "Unsupported action: {action}",
  "pokerStars.unknownPlayer":
    "Unknown player {playerId} at action {actionNumber}",
  "pokerStars.unknownPotWinner": "Unknown pot winner {playerId}",
  "pokerStars.duplicatePlayerId": "Duplicate player id: {playerId}",
  "pokerStars.duplicateSeat": "Duplicate seat: {seat}",
  "pokerStars.heroNotSeated": "Hero player {playerId} is not seated",
  "pokerStars.dealerSeatEmpty": "Dealer seat {seat} is empty",
  "pokerStars.minimumPlayers": "Hand needs at least two players",
  "pokerStars.unexpectedStreetOrder": "Unexpected street order: {street}",
  "pokerStars.boardCardCount": "{street} needs {expected} board cards",
  "pokerStars.invalidAmount": "Invalid amount at {where}",
  "pokerStars.inconsistentAmount":
    "Inconsistent amount at action {actionNumber}",
  "pokerStars.callExceedsAmount":
    "Call exceeds the amount to call at action {actionNumber}",
  "pokerStars.shortCallWithoutAllIn":
    "Short call without all-in at action {actionNumber}",
  "pokerStars.stackOvercommit":
    "Player {player} commits more than their stack at action {actionNumber}",
  "pokerStars.potTotalMismatch":
    "Pot total {pot} does not match contributions {contribution}",
  "pokerStars.potWinsMismatch":
    "Pot wins {collected} plus rake {rake} and jackpot {jackpot} do not match pot total {pot}",
  "pokerStarsEdit.sourceUnreadable": "The source hand history cannot be read.",
  "pokerStarsEdit.sourceCannotShow":
    "The source hand cannot be shown: {detail}",
  "pokerStarsEdit.lineCountChanged":
    "Adding or removing lines is not supported. Edit the existing lines.",
  "pokerStarsEdit.fixedLine":
    "This line cannot be edited. Editable: stacks, cards and actions.",
  "pokerStarsEdit.expectedSeat":
    'Expected "Seat {seat}: {player} (<stack> in chips)". Only the stack can be edited.',
  "pokerStarsEdit.expectedAction":
    'Expected "{player}: folds | checks | calls <amount> | bets <amount> | raises <increase> to <total>". The player cannot be changed.',
  "pokerStarsEdit.actionMissing": "This action is not in the source hand.",
  "pokerStarsEdit.expectedDealt":
    'Expected "Dealt to {player} [<cards>]". Only the hero\'s cards can be edited.',
  "pokerStarsEdit.expectedShows": 'Expected "{player}: shows [<cards>]".',
  "pokerStarsEdit.expectedStreet":
    "Expected the same street header with the same number of new cards.",
  "pokerStarsEdit.invalidCard": '"{card}" is not a card.',
  "pokerStarsEdit.expectedCards": "Expected {count} cards.",
  "pokerStarsEdit.cardsMissing": "These cards are not in the source hand.",
  "pokerStarsEdit.duplicateCard": "Duplicate card: {cards}",
  "pokerStarsEdit.editedCannotShow":
    "The edited hand cannot be shown: {detail}",
  "pokerStarsEdit.outputMismatch":
    "The edit does not match the hand it produces. Expected: {expected}",
  "pokerStarsEdit.shownCardsMustMatch":
    "Shown cards must match the dealt cards.",
  "pokerStarsEdit.noLine": "(no line)",
  "pokerStarsProjection.unknownError": "Unknown conversion error",
  "pokerStarsProjection.unsupportedInput": "Unsupported hand history input",
  "pokerStarsProjection.unsupportedDocument": "Unsupported OHH document",
  "handHistory.lineIssue": "Line {line} [{section}]: {message}",
  "ohh.expectedString": "expected a string",
  "ohh.expectedFiniteNumber": "expected a finite number",
  "ohh.expectedArray": "expected an array",
  "ohh.expectedObject": "expected an object",
  "ohh.expectedBoolean": "expected a boolean",
  "ohh.expectedArrayOrEmpty": 'expected an array, null, "", or omission',
  "ohh.expectedNonEmptyString": "expected a non-empty string",
  "ohh.expectedPlayer": "expected at least one player",
  "ohh.expectedRound": "expected at least one round",
  "ohh.badPotNumbering":
    "pot numbering matches neither the official 0-based nor the house 1-based convention",
  "ohh.expectedUnitMarker": 'expected "{unit}" when a unit marker is present',
  "ohh.expectedPositiveNumber": "expected a positive number",
  "ohh.invalidJson": "Invalid JSON: {error}",
  "ohh.jsonSyntaxError": "{error}",
  "ohhParser.missingGameNumber": "Missing game_number",
  "ohhParser.minimumPlayers": "Hand must have at least 2 players",
  "ohhParser.missingRounds": "Missing rounds",
  "ohhParser.heroNotFound": "Hero player not found",
  "ohhParser.preflopFoldedOut":
    "Cannot create apply config: Hand ended preflop with all players folding ({count} active player). Apply config requires postflop action with 2 active players.",
  "ohhParser.preflopActivePlayers":
    "Cannot create apply config: Hand ended preflop ({count} active players). Apply config requires postflop action with exactly 2 active players (heads-up).",
  "ohhParser.multiwayUnsupported":
    "Multiway pot detected ({count} players at flop). Only heads-up (2 players) is supported for apply config.",
  "ohhParser.notEnoughActivePlayers":
    "Not enough active players ({count} at flop). Heads-up (2 players) required for apply config.",
  "ohhParser.cannotIdentifyPositions": "Cannot identify positions: {reason}",
  "ohhParser.invalidHandState": "Invalid hand state",
  "ohhParser.postflopRequired":
    "Hand did not reach the flop. OOP/IP positions only apply to postflop play.",
  "ohhParser.playerSeatsNotFound":
    "Could not find player seats in hand.players",
  "ohhEditor.negativeStack": "Stack cannot be negative",
  "ohhEditor.negativeAmount": "Amount cannot be negative",
};
